import React, { useRef, useState, useEffect } from "react";
import FontIcon from "react-md/lib/FontIcons";
import { Row, Col } from "react-flexbox-grid";
import "../styles/assignedServiceProvider.css";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import EventService from "../../../../../service/event/EventService";
import CreateServiceUtil from "../services/CreateServiceUtil";
import TextField from "react-md/lib/TextFields";
import { Button } from "react-md";
import {
  ExpansionList,
  ExpansionPanel,
  SelectField,
  DialogContainer,
} from "react-md";
import ExpandableTable from "../helper/expandableTable";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import AssignServiceProviderUtil from "../services/AssignServiceProviderUtil";
import AvailabilityCalendar from "../helper/AvailabilityCalendar";
import CreateServiceProviderUtil from "../services/CreateServiceProviderUtil";
import CityTableAssignSP from "../helper/CityTableAssignSP";
import PatientsService from "../../../../ops/modules/patients/service/PatientsService";

function ServiceProviderActionScreen(props) {
  // const [serviceData, setServiceData] = useState({});
  // const [serviceProviderData, setServiceProviderData] = useState({});
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [editorStateCityInstruction, setEditorStateCityInstruction] = useState(
    EditorState.createEmpty(),
  );
  const [
    editorStatePhoneNoAndEmailInstruction,
    setEditorStatePhoneNoAndEmailInstruction,
  ] = useState(EditorState.createEmpty());
  const [isServiceProviderValidBoolValue, setIsServiceProviderValidBoolValue] =
    useState(false);
  const [serviceTypeData, setServiceTypeData] = useState({});
  const [loading, setLoading] = useState(false);
  const [tableDataEditAudits, setTableDataEditAudits] = useState({});
  const [cityMappings, setCityMappings] = useState({});
  const [cityMappingFilters, setCityMappingFilters] = useState({});
  const [initialCityMapping, setInitialCityMapping] = useState({});
  const [cityMappingOperationSelected, setCityMappingOperationSelected] =
    useState(null);
  const [showUpdateCityMappingNowDialog, setShowUpdateCityMappingNowDialog] =
    useState(false);

  const [showPropagationDialog, setShowPropagationDialog] = useState(null);
  const [errorObject, setErrorObject] = useState(null);
  const [showAllAgreementsModal, setShowAllAgreementsModal] = useState(false);
  const [localAgreements, setLocalAgreements] = useState(
    props?.data?.serviceProvider?.agreementDetails ?? [],
  );
  const [showAddAgreementDialog, setShowAddAgreementDialog] = useState(false);
  const [newAgreementForm, setNewAgreementForm] = useState({});
  const [addAgreementEditorState, setAddAgreementEditorState] = useState(
    EditorState.createEmpty(),
  );
  const [agreementPdfFile, setAgreementPdfFile] = useState(null);
  const [agreementPdfUploading, setAgreementPdfUploading] = useState(false);
  const [docToken, setDocToken] = useState("");
  const [editAgreementIndex, setEditAgreementIndex] = useState(null);
  const [showEditAgreementDialog, setShowEditAgreementDialog] = useState(false);
  const [editAgreementForm, setEditAgreementForm] = useState({});
  const [editAgreementEditorState, setEditAgreementEditorState] = useState(
    EditorState.createEmpty(),
  );
  const [editAgreementPdfFile, setEditAgreementPdfFile] = useState(null);
  const [editAgreementPdfUploading, setEditAgreementPdfUploading] =
    useState(false);
  const [showAuditModal, setShowAuditModal] = useState(false);
  const [auditData, setAuditData] = useState([]);
  const [auditAgreement, setAuditAgreement] = useState(null);
  const [auditLoading, setAuditLoading] = useState(false);
  const [agreementMenuAnchor, setAgreementMenuAnchor] = useState(null);
  const [agreementMenuPosition, setAgreementMenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const [agreementMenuIndex, setAgreementMenuIndex] = useState(null);
  const [agreementMenuItem, setAgreementMenuItem] = useState(null);

  // All agreements modal filter/pagination state
  const [allAgreementsData, setAllAgreementsData] = useState([]);
  const [allAgreementsTotal, setAllAgreementsTotal] = useState(0);
  const [allAgreementsPage, setAllAgreementsPage] = useState(1);
  const [allAgreementsPageSize] = useState(5);
  const [allAgreementsLoading, setAllAgreementsLoading] = useState(false);
  const [agreementFilters, setAgreementFilters] = useState({});
  const [agreementFilterOpen, setAgreementFilterOpen] = useState(null);

  const [mode, setMode] = useState(props?.data?.mode);
  const [originalMode, setOriginalMode] = useState(props?.data?.mode);

  const enablePricePerCityTextRef = useRef(null);

  const [isExpansionPanelExpanded, setIsExpansionPanelExpanded] = useState({
    firstPanel: false,
    secondPanel: false,
    thirdPanel: false,
  });
  const [assignedServiceProviderData, setAssignedServiceProviderData] =
    useState({
      service: props?.data?.service,
      serviceProvider: props?.data?.serviceProvider,
      serviceProviderAssignmentId: props?.data?.serviceProvider?.id,
      externalServiceId: {
        externalServiceId:
          props?.data?.serviceProvider?.externalServiceId ??
          (props?.data?.service?.serviceTypeId == 2 ||
          props?.data?.service?.serviceTypeId == 3
            ? props?.data?.service?.name
            : props?.data?.service?.serviceTypeId == 4
              ? props?.data?.service?.name
              : props?.data?.service?.serviceTypeId == 5
                ? props?.data?.service?.name
                : null),
        enabled: false,
      },
      externalServiceName:
        props?.data?.serviceProvider?.externalServiceName ?? "",
      externalServiceDescription:
        props?.data?.serviceProvider?.externalServiceDescription ?? "",
      isActive: props?.data?.serviceProvider?.isActive,
      isContinueClicked: false,
      masterAvailability: {
        config: {},
        schedule: {
          sunday: [],
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
        },
        unavailableTime: [],
        availableTime: [],
      },
    });
  const [SPbodyToUpdate, setSPbodyToUpdate] = useState(null);
  const [openPropCalendarChangesDialog, setOpenPropCalendarChangesDialog] =
    useState(false);

  const reverseConvertServiceModesData = (array) => {
    if (!Array.isArray(array) || array.length === 0) {
      return {}; // Return an empty object if input is null, undefined, or empty
    }

    const ans = array.reduce((acc, item) => {
      const { mode, ...rest } = item; // Extract mode as key, rest as value
      acc[mode] = rest;
      return acc;
    }, {});

    return ans;
  };

  const handleUpdateMode = (mode) => {
    props.data.mode = mode;
    setMode(mode);
  };

  const [
    assignedServiceProviderModesData,
    setAssignedServiceProviderModesData,
  ] = useState({});

  const createServiceUtil = new CreateServiceUtil();
  const assignServiceProviderUtil = new AssignServiceProviderUtil();
  const createServiceProviderUtil = new CreateServiceProviderUtil();
  const patientService = new PatientsService();

  useEffect(() => {
    getServiceTypeDataById(props?.data?.service?.serviceTypeId);
    generateDocumentToken();
    if (props?.data?.mode != "assign") {
      getServiceProviderDataByFilter(
        props?.data?.serviceProvider?.serviceProviderId,
        true,
      );

      let contentBlock = htmlToDraft(
        props?.data?.serviceProvider?.externalServiceDescription ?? "",
      );
      if (contentBlock) {
        let contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
        );
        let editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
      }

      fetchCityMappings(
        assignedServiceProviderData?.service?.id,
        assignedServiceProviderData?.serviceProvider?.serviceProviderId,
        1,
        {},
      );

      let modesCityMapping = {};
      (props?.data?.serviceProvider?.serviceModes ?? []).map((elem) => {
        if (elem?.mode) {
          modesCityMapping[elem.mode] = elem?.cityMapping ?? {};
          handleInitialiseCityInstruction(
            elem?.cityMapping?.instruction?.city ?? "",
          );
          handleInitialisePhoneNoAndEmailInstruction(
            elem?.cityMapping?.instruction?.phoneNoAndEmail ?? "",
          );
        }
      });

      setInitialCityMapping((prev) => modesCityMapping ?? {});
    }

    if (props?.data?.mode == "assign" && props?.data?.assignMode == "group") {
      getAllGroupVendors(true);
    }

    if (props?.data?.mode == "view") {
      setAssignedServiceProviderData((prev) => ({
        ...prev,
        isContinueClicked: true,
      }));
    }

    setAssignedServiceProviderModesData(
      reverseConvertServiceModesData(
        props?.data?.serviceProvider?.serviceModes,
      ),
    );
  }, []);

  useEffect(() => {}, [assignedServiceProviderModesData]);

  const generateDocumentToken = () => {
    patientService.getAndSaveDocumentToken(
      (response) => {
        localStorage.setItem("zy.bridge.doc.token", JSON.stringify(response));
        setDocToken(response.token);
      },
      (error) => {},
    );
  };

  const getServiceDataById = (id) => {
    let onResponse = (res) => {
      console.log("ni- got res for id=", res);
      // setServiceData(res);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching the service: ${err?.message}`,
      });
    };
    createServiceUtil.getServiceById(id, onResponse, onError);
  };

  const handleInitialiseCityInstruction = (instruction) => {
    let contentBlock = htmlToDraft(instruction ?? "");
    if (contentBlock) {
      let contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      let editorState = EditorState.createWithContent(contentState);
      setEditorStateCityInstruction(editorState);
    }
  };

  const handleInitialisePhoneNoAndEmailInstruction = (instruction) => {
    let contentBlock = htmlToDraft(instruction ?? "");
    if (contentBlock) {
      let contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      let editorState = EditorState.createWithContent(contentState);
      setEditorStatePhoneNoAndEmailInstruction(editorState);
    }
  };

  const getAssignedServiceProvidersDataByFilter = (body) => {
    setLoading(true);
    let onResponse = (res) => {
      setLoading(false);
      props.data.serviceProvider = res?.assignedServiceProviders?.[0] ?? {};

      reInitialize();
    };
    let onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error in fetching assigned service providers: ${err?.message}`,
      });
    };
    assignServiceProviderUtil.getAssignedServiceProvidersByFilter(
      body,
      onResponse,
      onError,
    );
  };

  const reInitialize = () => {
    getServiceProviderDataByFilter(
      props?.data?.serviceProvider?.serviceProviderId,
      true,
    );

    let contentBlock = htmlToDraft(
      props?.data?.serviceProvider?.externalServiceDescription ?? "",
    );
    if (contentBlock) {
      let contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      let editorState = EditorState.createWithContent(contentState);
      setEditorState(editorState);
    }

    fetchCityMappings(
      assignedServiceProviderData?.service?.id,
      assignedServiceProviderData?.serviceProvider?.id,
      1,
      {},
    );

    let modesCityMapping = {};
    (props?.data?.serviceProvider?.serviceModes ?? []).map((elem) => {
      if (elem?.mode) {
        modesCityMapping[elem.mode] = elem?.cityMapping ?? {};
        handleInitialiseCityInstruction(
          elem?.cityMapping?.instruction?.city ?? "",
        );
        handleInitialisePhoneNoAndEmailInstruction(
          elem?.cityMapping?.instruction?.phoneNoAndEmail ?? "",
        );
      }
    });
    setInitialCityMapping((prev) => modesCityMapping ?? {});
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  const _onEditorStateChange = (editorState) => {
    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setAssignedServiceProviderData((prev) => ({
      ...prev,
      externalServiceDescription: body,
    }));
    setEditorState(editorState);
  };

  const _onEditorStateChangeCityInstruction = (editorState, row) => {
    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    updateAssignedServiceProviderModesDataField(row.toString(), "cityMapping", {
      ...(assignedServiceProviderModesData?.[row]?.cityMapping ?? {}),
      instruction: {
        city: body,
        phoneNoAndEmail:
          assignedServiceProviderModesData?.[row]?.cityMapping?.instruction
            ?.phoneNoAndEmail ?? "",
      },
    });
    setEditorStateCityInstruction(editorState);
  };

  const _onEditorStateChangePhoneNoAndEmailInstruction = (editorState, row) => {
    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    updateAssignedServiceProviderModesDataField(row.toString(), "cityMapping", {
      ...(assignedServiceProviderModesData?.[row]?.cityMapping ?? {}),
      instruction: {
        city:
          assignedServiceProviderModesData?.[row]?.cityMapping?.instruction
            ?.city ?? "",
        phoneNoAndEmail: body,
      },
    });
    setEditorStatePhoneNoAndEmailInstruction(editorState);
  };

  const setAvailability = (newAvailability, mode) => {
    updateAssignedServiceProviderModesDataField(
      mode,
      "availability",
      newAvailability,
    );
  };

  let fetchCityMappings = (serviceId, serviceProviderId, pageNo, filters) => {
    setCityMappingFilters((prev) => ({ ...prev, ...filters }));
    setLoading(true);

    let onResponse = (res) => {
      setLoading(false);
      if (res != null) {
        setCityMappings((prev) => res);
      }
    };
    let onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceProviderUtil.getL2CityMappingByFilter(
      {
        pageNo: pageNo,
        pageSize: 30,
        serviceProviderId: serviceProviderId, // always mandatory, rest are optional
        serviceId: serviceId,
        status: (filters?.status ?? [])?.map((ele) => ele.value) ?? [], // multiple supported as array
        name: filters?.name ?? "", // regex substring supported
      },
      onResponse,
      onError,
    );
  };

  const EMPTY_CALENDAR = {
    config: {},
    schedule: {
      sunday: [],
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
    },
    unavailableTime: [],
    availableTime: [],
  };

  const updateCalendarAvailabilityConfig = (newValue, updateField, mode) => {
    const { config, ...rest } = assignedServiceProviderModesData?.[mode]
      ?.availability ?? {
      config: {},
      schedule: {
        sunday: [],
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
      },
      unavailableTime: [],
      availableTime: [],
    };
    const { [updateField]: val, ...restFields } = config ?? {};

    updateAssignedServiceProviderModesDataField(mode, "availability", {
      config: {
        [updateField]: newValue,
        ...restFields,
      },
      ...rest,
    });
  };

  const checkServiceProviderAssignedToService = (
    serviceId,
    serviceProvider,
  ) => {
    let onResponse = (res) => {
      console.log("ni- got getAssignedServiceProviderForService res =", res);
      EventService.emit("showError", {
        message: `Service provider (${serviceProvider?.id}) - is already assigned to this service.`,
      });
    };
    let onError = (err) => {
      if (err?.code == 404) {
        // not assigned already .. can proceed
        setAssignedServiceProviderData((prev) => ({
          ...prev,
          serviceProvider: serviceProvider,
        }));
        isServiceProviderValid(
          assignedServiceProviderData?.service,
          serviceProvider,
        );
        return;
      }
      EventService.emit("showError", {
        message: `Error in checking the service provider assignment status.`,
      });
    };
    assignServiceProviderUtil.getAssignedServiceProviderForService(
      serviceId,
      serviceProvider?.id,
      onResponse,
      onError,
    );
  };

  const getServiceProviderDataByFilter = (
    id,
    doNotResetModesData,
    vendorName,
  ) => {
    let onResponse = (res) => {
      if (!doNotResetModesData) {
        // resetting qssignedServiceProviderModesData because new master availability will come into picture now..
        setAssignedServiceProviderModesData({});
      }

      // resetting serviceprovider before giving new value from res.
      setAssignedServiceProviderData((prev) => ({
        ...prev,
        serviceProvider: null,
      }));

      console.log("ni- got servProv res for id=", res);

      if (!res?.providers?.[0]) {
        EventService.emit("showError", {
          message: `No active service provider found with id - ${id?.toString()}`,
        });
        return;
      }

      // props?.data?.mode == "update"
      // check if this service provider is already assigned to this service or not??
      if (
        props?.data?.mode == "view" ||
        (props?.data?.mode == "update" &&
          props?.data?.serviceProvider?.serviceProviderId == id) ||
        (props?.data?.mode == "assign" && props?.data?.assignMode == "group")
      ) {
        setAssignedServiceProviderData((prev) => ({
          ...prev,
          serviceProvider: res?.providers?.[0],
        }));
        isServiceProviderValid(
          assignedServiceProviderData?.service,
          res?.providers?.[0],
        );
      } else {
        checkServiceProviderAssignedToService(
          assignedServiceProviderData?.service?.id,
          res?.providers?.[0],
        );
      }

      // setting calendar schedule availability acc. to this service provider
      if (res?.providers?.[0]?.serviceTypeId == 1) {
        setAssignedServiceProviderData((prev) => ({
          ...prev,
          masterAvailability:
            res?.providers?.[0]?.consultationInfo?.availability,
        }));
      } else if (res?.providers?.[0]?.serviceTypeId == 2) {
        setAssignedServiceProviderData((prev) => ({
          ...prev,
          masterAvailability: res?.providers?.[0]?.checkupInfo?.availability,
        }));
      } else if (res?.providers?.[0]?.serviceTypeId == 3) {
        setAssignedServiceProviderData((prev) => ({
          ...prev,
          masterAvailability: res?.providers?.[0]?.vaccineInfo?.availability,
        }));
      } else if (res?.providers?.[0]?.serviceTypeId == 5) {
        setAssignedServiceProviderData((prev) => ({
          ...prev,
          masterAvailability: res?.providers?.[0]?.dentalInfo?.availability,
        }));
      }
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching the service provider details: ${err?.message}`,
      });
    };
    assignServiceProviderUtil.getServiceProviderByFilter(
      vendorName
        ? {
            pageNum: 1,
            pageSize: 1,
            status: "active",
            groupNameMatch: [vendorName],
          }
        : {
            pageNum: 1,
            pageSize: 1,
            status:
              props?.data?.mode == "view" ||
              (props?.data?.mode == "update" &&
                props?.data?.serviceProvider.serviceProviderId != null &&
                id != null &&
                props?.data?.serviceProvider.serviceProviderId == id)
                ? null
                : "active",
            Ids: [stringToInt(id)],
          },
      onResponse,
      onError,
    );
  };

  const getAllGroupVendors = (status) => {
    let onResponse = (res) => {
      console.log("ni- got getAllGroupVendors res =", res);
      // setServiceProviderData(res);
      setAssignedServiceProviderData((prev) => ({
        ...prev,
        groupVendors: res,
      }));
      // isServiceProviderValid(assignedServiceProviderData?.service, res);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching the service provider details: ${err?.message}`,
      });
    };
    // assignServiceProviderUtil.getAllGroupVendors(status, onResponse, onError);
    createServiceProviderUtil.getGroupVendorsByFilter(
      {
        serviceTypeId: props?.data?.service?.serviceTypeId,
        status: status,
      },
      onResponse,
      onError,
    );
  };

  const getServiceTypeDataById = (id) => {
    let onResponse = (res) => {
      console.log("ni- got servType res for id=", res);
      setServiceTypeData(res);
      // setAssignedServiceProviderData({service: assignedServiceProviderData?.service, serviceProvider: res});
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching the service provider details: ${err?.message}`,
      });
    };
    assignServiceProviderUtil.getServiceTypeById(id, onResponse, onError);
  };

  const assignServiceProvider = (
    body,
    propagate,
    syncLevels = false,
    showUpdateCityMappingNowDialog = false,
  ) => {
    let onResponse = (res) => {
      console.log("ni- got assignServProv res for id=", res);

      if (
        showUpdateCityMappingNowDialog &&
        !(props?.data?.mode == "assign" && props?.data?.assignMode == "group")
      ) {
        setShowUpdateCityMappingNowDialog(true);
        return;
      }
      if (props?.data?.mode == "update" || cityMappingOperationSelected === 2) {
        EventService.emit("showError", {
          message: `Successfully updated the service provider assignment.`,
        });
        exitPage();
      }
      if (props?.data?.mode == "assign") {
        EventService.emit("showError", {
          message: `Successfully assigned the service provider.`,
        });
        exitPage();
      }
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in assigning the service provider: ${err?.message}`,
      });
    };
    if (props?.data?.mode == "view" && !(cityMappingOperationSelected === 2)) {
      EventService.emit("showError", {
        message: `You are currently in view mode. Cannot update details.`,
      });
    }
    if (
      (props?.data?.mode == "update" || cityMappingOperationSelected === 2) &&
      isFormValid(
        assignedServiceProviderData?.service,
        assignedServiceProviderData?.serviceProvider,
      )
    ) {
      updateAssignedSP(
        body,
        propagate,
        syncLevels,
        showUpdateCityMappingNowDialog,
      );
    }
    if (
      props?.data?.mode == "assign" &&
      props?.data?.assignMode == "group" &&
      isFormValid(
        assignedServiceProviderData?.service,
        assignedServiceProviderData?.serviceProvider,
      )
    ) {
      assignServiceProviderUtil.assignServiceProviderByGroupVendorId(
        body,
        onResponse,
        onError,
      );
    } else if (
      props?.data?.mode == "assign" &&
      isFormValid(
        assignedServiceProviderData?.service,
        assignedServiceProviderData?.serviceProvider,
      )
    ) {
      assignServiceProviderUtil.assignServiceProvider(
        body,
        onResponse,
        onError,
      );
    }
  };

  const updateAssignedSP = (
    body,
    propagate,
    syncLevels = false,
    showUpdateCityMappingNowDialog = false,
  ) => {
    if (propagate === undefined) {
      let onResponse = (res) => {
        if (res.updateRequired) {
          setSPbodyToUpdate(body);
          setOpenPropCalendarChangesDialog(true);
        } else {
          if (showUpdateCityMappingNowDialog) {
            setShowUpdateCityMappingNowDialog(true);
            return;
          }
          EventService.emit("showError", {
            message: `Successfully updated the service provider assignment.`,
          });
          exitPage();
        }
      };
      let onError = (err) => {
        EventService.emit("showError", {
          message: `Error in assigning the service provider: ${err?.message}`,
        });
      };

      (body?.serviceModes ?? []).forEach((element) => {
        if (element?.mode === "Subscription") {
          element.cityMapping = {
            ...(element.cityMapping ?? {}),
            syncLevels: syncLevels,
          };
        }
      });

      assignServiceProviderUtil.updateAssignedServiceProvider1(
        assignedServiceProviderData?.serviceProviderAssignmentId,
        body,
        onResponse,
        onError,
      );
    } else if (propagate === 1) {
      let onResponse = (res) => {
        if (showUpdateCityMappingNowDialog) {
          setShowUpdateCityMappingNowDialog(true);
          return;
        }
        EventService.emit("showError", {
          message: `Successfully updated the service provider assignment.`,
        });
        exitPage();
      };
      let onError = (err) => {
        setSPbodyToUpdate(null);
        setOpenPropCalendarChangesDialog(false);
        EventService.emit("showError", {
          message: `Error in assigning the service provider: ${err?.message}`,
        });
      };

      assignServiceProviderUtil.updateAssignedServiceProvider2(
        assignedServiceProviderData?.serviceProviderAssignmentId,
        body,
        onResponse,
        onError,
      );
    } else if (propagate === 2) {
      let onResponse = (res) => {
        if (showUpdateCityMappingNowDialog) {
          setShowUpdateCityMappingNowDialog(true);
          return;
        }
        EventService.emit("showError", {
          message: `Successfully updated the service provider assignment.`,
        });
        exitPage();
      };
      let onError = (err) => {
        setSPbodyToUpdate(null);
        setOpenPropCalendarChangesDialog(false);
        EventService.emit("showError", {
          message: `Error in assigning the service provider: ${err?.message}`,
        });
      };

      assignServiceProviderUtil.updateAssignedServiceProvider(
        assignedServiceProviderData?.serviceProviderAssignmentId,
        body,
        onResponse,
        onError,
      );
    }
  };

  const convertServiceModesData = (data) => {
    if (!data || Object.keys(data).length === 0) {
      return []; // Return an empty array if data is null, undefined, or empty
    }

    return Object.entries(data).map(([key, value]) => ({
      mode: key,
      ...value,
    }));
  };

  const prepareAgreementDetailsForSave = () => {
    console.log(
      "PREPARE AGREEMENTS - localAgreements comments:",
      (localAgreements ?? []).map((a) => ({
        mode: a.mode,
        comment: a.comment,
      })),
    );
    if (props?.data?.mode == "update") {
      return (localAgreements ?? []).map(({ _isNew, ...rest }) => rest);
    }
    return (localAgreements ?? []).map(
      ({
        _isNew,
        id,
        status,
        serviceId,
        serviceProviderId,
        createdAt,
        updatedAt,
        agreementDocumentThumbnailUrl,
        agreementDocumentUrl,
        ...rest
      }) => rest,
    );
  };

  const prepareBodyForAssignServiceProvider = () => {
    if (props?.data?.mode == "assign" && props?.data?.assignMode == "group") {
      return {
        serviceId: assignedServiceProviderData?.service?.id,
        providerGroupId: assignedServiceProviderData?.selectedGroupVendor?.id,
        isActive: assignedServiceProviderData?.isActive,
        externalServiceId:
          assignedServiceProviderData?.externalServiceId?.externalServiceId,
        externalServiceName: assignedServiceProviderData?.externalServiceName,
        externalServiceDescription:
          assignedServiceProviderData?.externalServiceDescription,
        agreementDetails: prepareAgreementDetailsForSave(),
        serviceModes: convertServiceModesData(assignedServiceProviderModesData),
      };
    }
    return {
      serviceId: assignedServiceProviderData?.service?.id,
      serviceProviderId: assignedServiceProviderData?.serviceProvider?.id,
      isActive: assignedServiceProviderData?.isActive,
      externalServiceId:
        assignedServiceProviderData?.externalServiceId?.externalServiceId,
      externalServiceName: assignedServiceProviderData?.externalServiceName,
      externalServiceDescription:
        assignedServiceProviderData?.externalServiceDescription,
      agreementDetails: prepareAgreementDetailsForSave(),
      serviceModes: convertServiceModesData(assignedServiceProviderModesData),
    };
  };

  let isFormValid = (service, serviceProvider) => {
    let isServiceProviderValidBool = isServiceProviderValid(
      service,
      serviceProvider,
    );
    if (!isServiceProviderValidBool) {
      return false;
    } else {
      if (props?.data?.mode != "assign") {
        const assignId =
          assignedServiceProviderData?.serviceProviderAssignmentId; // Get the value safely
        if (
          assignId == undefined ||
          assignId == null ||
          assignId.trim() === ""
        ) {
          EventService.emit("showError", {
            message: `Unable to fetch assignment Id.`,
          });
          return false;
        }
      }

      // add required fields as validation targets to validate them.
      let validationTargets = {
        service: ["id"],
        // serviceProvider: ["id", "isActive"],
        serviceProvider: ["id"],
      };
      if (props?.data?.mode == "assign" && props?.data?.assignMode == "group") {
        validationTargets = {}; //no validation is required in service provider details for this case
        if (
          assignedServiceProviderData?.isActive == null ||
          assignedServiceProviderData?.isActive == undefined
        ) {
          EventService.emit("showError", {
            message: `Service provider status is a required field.`,
          });
          return false;
        }
      } else {
        if (
          assignedServiceProviderData?.isActive == null ||
          assignedServiceProviderData?.isActive == undefined
        ) {
          EventService.emit("showError", {
            message: `Service provider status is a required field.`,
          });
          return false;
        }
        if (
          (assignedServiceProviderData?.serviceProvider?.serviceTypeId == 2 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId == 3 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId == 4 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId == 5) &&
          (assignedServiceProviderData?.externalServiceId?.externalServiceId ==
            null ||
            assignedServiceProviderData?.externalServiceId?.externalServiceId ==
              undefined ||
            assignedServiceProviderData?.externalServiceId?.externalServiceId.trim() ==
              "")
        ) {
          EventService.emit("showError", {
            message: `External service id is a required field.`,
          });
          return false;
        }
      }
      const modesRequiredFields = ["price", "modeStatus"];
      const modesConfigRequiredFields =
        assignedServiceProviderData?.serviceProvider?.serviceTypeId == 4
          ? []
          : [
              "slotDurationInMinutes",
              "bookingPerSlot",
              "minBookingDays",
              "maxAdvBookingDays",
            ];

      let errorOccurred = false;
      Object.entries(validationTargets).forEach(([key, values]) => {
        values.forEach((val) => {
          if (errorOccurred) return;
          const value = assignedServiceProviderData?.[key]?.[val];
          console.log(`  - ${val} is required in ${key} details: ${value}`);
          if (value == null || value?.toString()?.trim() === "") {
            EventService.emit("showError", {
              message: `${val} is required in ${key} details.`,
            });
            errorOccurred = true;
          }
        });
        // }
      });

      if (errorOccurred) {
        return false;
      }

      errorOccurred = false;

      if (
        assignedServiceProviderData?.isContinueClicked &&
        (!assignedServiceProviderModesData ||
          (Object.keys(assignedServiceProviderModesData).length === 0 &&
            assignedServiceProviderModesData.constructor === Object))
      ) {
        // assignedServiceProviderModesData is null, undefined, or an empty object
        EventService.emit("showError", {
          message: `Please select at least one mode.`,
        });
        errorOccurred = true;
      }

      if (errorOccurred) {
        return false;
      }

      errorOccurred = false;

      Object.entries(assignedServiceProviderModesData).forEach(
        ([key, values]) => {
          modesRequiredFields.forEach((e) => {
            if (errorOccurred) return;
            if (assignedServiceProviderModesData?.[key]?.enabled) {
              const value = assignedServiceProviderModesData?.[key]?.[e];
              // console.log(`  - ${val} is required in ${key} details: ${value}`);
              if (value == null || value?.toString()?.trim() === "") {
                EventService.emit("showError", {
                  message: `${e} is required in ${key} mode details.`,
                });
                errorOccurred = true;
              }
            }
          });
        },
      );

      if (errorOccurred) {
        return false;
      }

      errorOccurred = false;
      Object.entries(assignedServiceProviderModesData).forEach(
        ([key, values]) => {
          modesConfigRequiredFields.forEach((e) => {
            if (errorOccurred) return;
            if (
              assignedServiceProviderModesData?.[key]?.enabled &&
              assignedServiceProviderData?.serviceProvider?.serviceTypeId != 4
            ) {
              const value =
                assignedServiceProviderModesData?.[key]?.availability?.config?.[
                  e
                ];
              // console.log(`  - ${val} is required in ${key} details: ${value}`);
              if (value == null || value?.toString()?.trim() === "") {
                EventService.emit("showError", {
                  message: `${e} is required in ${key} mode details.`,
                });
                errorOccurred = true;
              }
            }
          });
        },
      );

      if (errorOccurred) {
        return false;
      }

      // check if any day is enabled in calendar schedule but the values of start and end time is empty
      errorOccurred = false;
      Object.entries(assignedServiceProviderModesData).forEach(
        ([key, values]) => {
          if (
            assignedServiceProviderData?.serviceProvider?.serviceTypeId != 4 &&
            assignedServiceProviderModesData?.[key]?.availability?.schedule
          ) {
            Object.entries(
              assignedServiceProviderModesData[key].availability.schedule,
            ).forEach(([eKey, eValue]) => {
              if (errorOccurred) return;
              if (assignedServiceProviderModesData?.[key]?.enabled) {
                const values = eValue;
                if (values && values.length > 0) {
                  values.forEach((value) => {
                    if (
                      value?.start == null ||
                      value?.start?.toString()?.trim() === "" ||
                      value?.end == null ||
                      value?.end?.toString()?.trim() === ""
                    ) {
                      EventService.emit("showError", {
                        message: `Please fill start and end time for slot on ${eKey.toString()} OR disable the checkbox for ${eKey.toString()}`,
                      });
                      errorOccurred = true;
                    }
                  });
                }
              }
            });
          }
        },
      );

      if (errorOccurred) {
        return false;
      }

      return true;
    }

    return true;
  };

  const returnTableDataWithEditsApplied = (
    cityMappings,
    tableDataEditAudits,
  ) => {
    return mergeUpdates(cityMappings?.cityEntities ?? [], tableDataEditAudits);
  };

  const mergeUpdates = (data, audits) => {
    const mergedData = data.map((item) => {
      const audit = audits[item.id];
      return audit
        ? { ...item, ...audit } // merge original and audit (audit overrides)
        : item; // no change if no matching audit
    });

    return mergedData;
  };

  const removeKey = (obj, keyToRemove) => {
    const newObj = { ...obj }; // Create a shallow copy to avoid mutating the original object
    delete newObj[keyToRemove]; // Delete the key
    return newObj;
  };

  let isServiceProviderValid = (service, serviceProvider) => {
    if (props?.data?.mode == "assign" && props?.data?.assignMode == "group") {
      if (
        assignedServiceProviderData?.selectedGroupVendor?.id &&
        assignedServiceProviderData?.selectedGroupVendor?.name
      ) {
        setIsServiceProviderValidBoolValue((prev) => true);
        return true;
      }
      EventService.emit("showError", {
        message: `Please select a group vendor.`,
      });
      setIsServiceProviderValidBoolValue((prev) => false);
      return false;
    }

    let invalid = false;
    if (service?.serviceTypeId != serviceProvider?.serviceTypeId) {
      invalid = true;
    }
    if (
      service?.serviceSubtypeId !== 0 &&
      service?.serviceSubtypeId != serviceProvider?.serviceSubtypeId
    ) {
      invalid = true;
    }

    if (invalid) {
      EventService.emit("showError", {
        message: `The service provider's type/subtype does not match with the type/subtype of this service. Please try with some other service provider.`,
      });
    }
    setIsServiceProviderValidBoolValue((prev) => !invalid);
    return !invalid;
  };

  const updateAssignedServiceProviderDataField = (
    parentKey,
    fieldKey,
    newValue,
  ) => {
    // setAssignedServiceProviderData({serviceProvider: {id: "176df7y"}})

    setAssignedServiceProviderData((prevData) => ({
      ...prevData,
      [parentKey]: {
        ...prevData[parentKey],
        [fieldKey]: newValue,
      },
    }));
  };

  const updateAssignedServiceProviderModesDataField = (
    parentKey,
    fieldKey,
    newValue,
  ) => {
    // setAssignedServiceProviderData({serviceProvider: {id: "176df7y"}})

    setAssignedServiceProviderModesData((prevData) => ({
      ...prevData,
      [parentKey]: {
        ...prevData[parentKey],
        [fieldKey]: newValue,
      },
    }));
    if (fieldKey === "enabled" && newValue === false) {
      const newObj = removeKey(assignedServiceProviderModesData, parentKey);
      setAssignedServiceProviderModesData(newObj);
    }
  };

  const isServiceProviderValidForConfirm = () => {
    return isFormValid();
  };

  const handleUpdateTableCityEntity = (cityEntity, cityEntityOld) => {
    if (cityEntity?.id) {
      // if (cityEntity?.status === 3) {
      //   // delete entry from city Mappings
      //   const updatedCityMappings = (cityMappings?.cityEntities ?? []).filter(
      //     (item) => item.id !== cityEntity.id
      //   );
      //   setCityMappings((prev) => ({
      //     ...prev,
      //     cityEntities: updatedCityMappings,
      //   }));
      //   return;
      // }
      // checking whether it already exist in audits.. if yes , then it means it not the original value recieved from backend it has been updated atleast once on local.
      if (!Boolean(tableDataEditAudits?.[cityEntity.id])) {
        cityEntity["originalEntity"] = cityEntityOld;
      }

      setTableDataEditAudits((prev) => ({
        ...prev,
        [cityEntity.id]: cityEntity,
      }));
    }
  };

  const getServiceProviderDetailsSection = () => {
    return props?.data?.mode == "assign" &&
      props?.data?.assignMode == "group" ? (
      <div className="service-details-container">
        <Row>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">
                {`Group vendor`}
                <label className="mp-label-red"> *</label>
              </div>
              <div style={{ marginTop: "10px" }}>
                <SelectField
                  id="groupVendor"
                  placeholder="Select"
                  name="groupVendor"
                  menuItems={assignedServiceProviderData?.groupVendors?.map(
                    (item) => item?.name,
                  )}
                  fullWidth
                  onChange={(e, idx) => {
                    updateAssignedServiceProviderDataField(
                      "selectedGroupVendor",
                      "id",
                      assignedServiceProviderData?.groupVendors?.[idx]?.id,
                    );
                    updateAssignedServiceProviderDataField(
                      "selectedGroupVendor",
                      "name",
                      e,
                    );
                  }}
                  value={assignedServiceProviderData?.selectedGroupVendor?.name}
                  disabled={
                    props?.data?.mode == "view" ||
                    (assignedServiceProviderData?.isContinueClicked ?? false)
                  }
                />
              </div>
            </div>
          </Col>
          {(assignedServiceProviderData?.serviceProvider?.serviceTypeId == 2 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId == 3 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId == 4 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId ==
              5) && (
            <Col xs={12} sm={5} md={4} lg={4}>
              <span>
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={
                    assignedServiceProviderData?.externalServiceId?.enabled ??
                    false
                  }
                  color="secondary"
                  disabled={props?.data?.mode == "view"}
                  onChange={(e) => {
                    updateAssignedServiceProviderDataField(
                      "externalServiceId",
                      "enabled",
                      e.target.checked,
                    );
                    if (
                      e.target.checked == false &&
                      (assignedServiceProviderData?.serviceProvider
                        ?.serviceTypeId == 2 ||
                        assignedServiceProviderData?.serviceProvider
                          ?.serviceTypeId == 3 ||
                        assignedServiceProviderData?.serviceProvider
                          ?.serviceTypeId == 4 ||
                        assignedServiceProviderData?.serviceProvider
                          ?.serviceTypeId == 5)
                    ) {
                      updateAssignedServiceProviderDataField(
                        "externalServiceId",
                        "externalServiceId",
                        assignedServiceProviderData?.service?.name,
                      );
                    }
                  }}
                />
                <span className="mp-label"> &nbsp;External service code</span>

                <label className="mp-label-red"> *</label>
              </span>
              <TextField
                id="externalServiceId"
                name="externalServiceId"
                type="text"
                onChange={(e) =>
                  updateAssignedServiceProviderDataField(
                    "externalServiceId",
                    "externalServiceId",
                    e,
                  )
                }
                placeholder="Type here"
                disabled={
                  !(
                    assignedServiceProviderData?.externalServiceId?.enabled ??
                    false
                  ) || props?.data?.mode == "view"
                }
                value={
                  assignedServiceProviderData?.externalServiceId
                    ?.externalServiceId
                }
              />
            </Col>
          )}
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">
                {`Service provider status`}
                <label className="mp-label-red"> *</label>
              </div>
              <div style={{ height: "10px" }}></div>
              <div>
                <SelectField
                  id="serviceProviderStatus"
                  name="serviceProviderStatus"
                  menuItems={["Active", "Inactive"]}
                  placeholder="Select"
                  fullWidth
                  onChange={
                    (e) =>
                      setAssignedServiceProviderData((prev) => ({
                        ...prev,
                        isActive: e == "Active" ? true : false,
                      }))
                    // updateAssignedServiceProviderDataField(
                    //   "serviceProvider",
                    //   "isActive",
                    //   e == "Active" ? true : false
                    // )
                  }
                  value={
                    assignedServiceProviderData?.isActive == true
                      ? "Active"
                      : assignedServiceProviderData?.isActive == false
                        ? "Inactive"
                        : ""
                  }
                  disabled={
                    props?.data?.mode == "view" ||
                    (assignedServiceProviderData?.isContinueClicked ?? false)
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
        {getAgreementDetailsSection()}
        <Row>
          <Button
            style={{ marginLeft: "8px", textTransform: "none" }}
            raised
            secondary
            disabled={
              (!isServiceProviderValidBoolValue &&
                !(
                  props?.data?.mode == "assign" &&
                  props?.data?.assignMode == "group"
                )) ||
              (!assignedServiceProviderData?.selectedGroupVendor &&
                props?.data?.mode == "assign" &&
                props?.data?.assignMode == "group") ||
              (assignedServiceProviderData?.isContinueClicked ?? false)
            }
            onClick={() => {
              if (isServiceProviderValidForConfirm()) {
                if (
                  props?.data?.mode == "assign" &&
                  props?.data?.assignMode == "group"
                ) {
                  getServiceProviderDataByFilter(
                    null,
                    null,
                    assignedServiceProviderData?.selectedGroupVendor?.name,
                  );
                }
                setAssignedServiceProviderData((prev) => ({
                  ...prev,
                  isContinueClicked: true,
                }));
              }
            }}
          >
            Confirm
          </Button>
        </Row>
      </div>
    ) : (
      <div className="service-details-container">
        <Row>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">
                {`Service provider ID`}
                <label className="mp-label-red"> *</label>
              </div>
              <div>
                <TextField
                  id="serviceProviderId"
                  name="serviceProviderId"
                  placeholder="Select"
                  type="text"
                  disabled={
                    props?.data?.mode == "view" ||
                    (assignedServiceProviderData?.isContinueClicked ?? false)
                  }
                  value={assignedServiceProviderData?.serviceProvider?.id ?? ""}
                  // error={!assignedServiceProviderData?.serviceProvider?.id}
                  // errorText={this.state.error.phoneno}
                  onChange={(e) => {
                    setAssignedServiceProviderData((prev) => ({
                      ...prev,
                      serviceProvider: null,
                    }));
                    updateAssignedServiceProviderDataField(
                      "serviceProvider",
                      "id",
                      e,
                    );
                  }}
                  inlineIndicator={
                    <Button
                      icon
                      className="text-fields__inline-btn"
                      disabled={
                        !assignedServiceProviderData?.serviceProvider?.id ||
                        (assignedServiceProviderData?.isContinueClicked ??
                          false)
                      }
                      style={{
                        margin: "-10px",
                      }}
                    >
                      <FontIcon
                        style={{
                          color: "orange",
                          lineHeight: "0",
                          marginBottom: "15px",
                        }}
                        onClick={() => {
                          // check if this service provider is already assigned to this service And proceed
                          getServiceProviderDataByFilter(
                            assignedServiceProviderData?.serviceProvider?.id,
                          );
                        }}
                      >
                        arrow_forward
                      </FontIcon>
                    </Button>
                  }
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">
                {`Service provider name`}
                <label className="mp-label-red"> *</label>
              </div>
              <div>
                <TextField
                  id="serviceProviderName"
                  name="serviceProviderName"
                  type="text"
                  placeholder="Name"
                  disabled
                  value={
                    assignedServiceProviderData?.serviceProvider
                      ?.serviceTypeId == 5
                      ? assignedServiceProviderData?.serviceProvider?.dentalInfo
                          ?.identityDetails?.name
                      : assignedServiceProviderData?.serviceProvider
                            ?.serviceTypeId == 4
                        ? assignedServiceProviderData?.serviceProvider?.gymInfo
                            ?.identityDetails?.name
                        : assignedServiceProviderData?.serviceProvider
                              ?.serviceTypeId == 3
                          ? assignedServiceProviderData?.serviceProvider
                              ?.vaccineInfo?.identityDetails?.name
                          : assignedServiceProviderData?.serviceProvider
                                ?.serviceTypeId == 2
                            ? assignedServiceProviderData?.serviceProvider
                                ?.checkupInfo?.identityDetails?.name
                            : (assignedServiceProviderData?.serviceProvider
                                ?.consultationInfo?.identityDetails?.name ?? "")
                  }
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">
                {`Service provider status`}
                <label className="mp-label-red"> *</label>
              </div>
              <div>
                <SelectField
                  id="serviceProviderStatus"
                  name="serviceProviderStatus"
                  menuItems={["Active", "Inactive"]}
                  placeholder="Select"
                  fullWidth
                  onChange={
                    (e) =>
                      setAssignedServiceProviderData((prev) => ({
                        ...prev,
                        isActive: e == "Active" ? true : false,
                      }))
                    // updateAssignedServiceProviderDataField(
                    //   "serviceProvider",
                    //   "isActive",
                    //   e == "Active" ? true : false
                    // )
                  }
                  value={
                    assignedServiceProviderData?.isActive == true
                      ? "Active"
                      : assignedServiceProviderData?.isActive == false
                        ? "Inactive"
                        : ""
                  }
                  disabled={
                    props?.data?.mode == "view" ||
                    (assignedServiceProviderData?.isContinueClicked ?? false)
                  }
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          {Boolean(
            assignedServiceProviderData?.serviceProvider?.serviceTypeId === 2
              ? assignedServiceProviderData?.serviceProvider?.checkupInfo
                  ?.vendorGroup?.vendorName
              : assignedServiceProviderData?.serviceProvider?.serviceTypeId ===
                  3
                ? assignedServiceProviderData?.serviceProvider?.vaccineInfo
                    ?.vendorGroup?.vendorName
                : assignedServiceProviderData?.serviceProvider
                      ?.serviceTypeId === 5
                  ? assignedServiceProviderData?.serviceProvider?.dentalInfo
                      ?.vendorGroup?.vendorName
                  : null,
          ) && (
            <Col xs={12} sm={5} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Group vendor`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <TextField
                    id="groupVendor"
                    name="groupVendor"
                    label=""
                    type="text"
                    disabled
                    value={
                      assignedServiceProviderData?.serviceProvider
                        ?.serviceTypeId === 2
                        ? assignedServiceProviderData?.serviceProvider
                            ?.checkupInfo?.vendorGroup?.vendorName
                        : assignedServiceProviderData?.serviceProvider
                              ?.serviceTypeId === 3
                          ? assignedServiceProviderData?.serviceProvider
                              ?.vaccineInfo?.vendorGroup?.vendorName
                          : assignedServiceProviderData?.serviceProvider
                                ?.serviceTypeId === 5
                            ? assignedServiceProviderData?.serviceProvider
                                ?.dentalInfo?.vendorGroup?.vendorName
                            : ""
                    }
                  />
                </div>
              </div>
            </Col>
          )}

          {(assignedServiceProviderData?.serviceProvider?.serviceTypeId == 2 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId == 3 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId == 4 ||
            assignedServiceProviderData?.serviceProvider?.serviceTypeId ==
              5) && (
            <Col xs={12} sm={5} md={4} lg={4}>
              <span>
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={
                    assignedServiceProviderData?.externalServiceId?.enabled ??
                    false
                  }
                  color="secondary"
                  disabled={props?.data?.mode == "view"}
                  onChange={(e) => {
                    updateAssignedServiceProviderDataField(
                      "externalServiceId",
                      "enabled",
                      e.target.checked,
                    );
                    if (
                      e.target.checked == false &&
                      (assignedServiceProviderData?.serviceProvider
                        ?.serviceTypeId == 2 ||
                        assignedServiceProviderData?.serviceProvider
                          ?.serviceTypeId == 3 ||
                        assignedServiceProviderData?.serviceProvider
                          ?.serviceTypeId == 4 ||
                        assignedServiceProviderData?.serviceProvider
                          ?.serviceTypeId == 5)
                    ) {
                      updateAssignedServiceProviderDataField(
                        "externalServiceId",
                        "externalServiceId",
                        assignedServiceProviderData?.service?.name,
                      );
                    }
                  }}
                />
                <span className="mp-label"> &nbsp;External service code</span>
                <label className="mp-label-red"> *</label>
              </span>
              <TextField
                id="externalServiceId"
                name="externalServiceId"
                type="text"
                onChange={(e) =>
                  updateAssignedServiceProviderDataField(
                    "externalServiceId",
                    "externalServiceId",
                    e,
                  )
                }
                placeholder="Type here"
                disabled={
                  !(
                    assignedServiceProviderData?.externalServiceId?.enabled ??
                    false
                  ) || props?.data?.mode == "view"
                }
                value={
                  assignedServiceProviderData?.externalServiceId
                    ?.externalServiceId
                }
              />
            </Col>
          )}
        </Row>
        {getAgreementDetailsSection()}
        <Row>
          <Button
            style={{ marginLeft: "8px", textTransform: "none" }}
            raised
            secondary
            disabled={
              !isServiceProviderValidBoolValue ||
              (assignedServiceProviderData?.isContinueClicked ?? false)
            }
            onClick={() => {
              if (isServiceProviderValidForConfirm()) {
                setAssignedServiceProviderData((prev) => ({
                  ...prev,
                  isContinueClicked: true,
                }));
              }
            }}
          >
            Confirm
          </Button>
        </Row>
      </div>
    );
  };

  const getAgreementStatusLabel = (status) => {
    switch (status) {
      case 1:
        return { label: "Upcoming", className: "agreement-status-upcoming" };
      case 2:
        return { label: "Active", className: "agreement-status-active" };
      case 3:
        return { label: "Expired", className: "agreement-status-expired" };
      case 4:
        return { label: "Inactive", className: "agreement-status-inactive" };
      default:
        return { label: "-", className: "" };
    }
  };

  const formatAgreementDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    const day = date.getDate();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const uploadAgreementPdf = (file) => {
    return new Promise((resolve, reject) => {
      const data = new FormData();
      data.append("file", file, file.name);
      createServiceUtil.uploadAgreementDoc(
        data,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        },
      );
    });
  };

  const openPdfInNewTab = (url) => {
    const pdfUrl = url + (docToken ? "?token=" + docToken : "");
    fetch(pdfUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const blobUrl = URL.createObjectURL(
          new Blob([blob], { type: "application/pdf" }),
        );
        window.open(blobUrl, "_blank");
      })
      .catch(() => {
        window.open(pdfUrl, "_blank");
      });
  };

  const handleOpenAddAgreementDialog = () => {
    setNewAgreementForm({});
    setAddAgreementEditorState(EditorState.createEmpty());
    setAgreementPdfFile(null);
    setShowAddAgreementDialog(true);
  };

  const handleSaveNewAgreement = () => {
    if (!newAgreementForm?.mode) {
      EventService.emit("showError", {
        message: "Please select a service mode.",
      });
      return;
    }
    if (newAgreementForm?.price == null || newAgreementForm?.price === "") {
      EventService.emit("showError", { message: "Please enter cost price." });
      return;
    }
    if (!newAgreementForm?.agreementStartDate) {
      EventService.emit("showError", {
        message: "Please select agreement start date.",
      });
      return;
    }
    if (!newAgreementForm?.agreementEndDate) {
      EventService.emit("showError", {
        message: "Please select agreement end date.",
      });
      return;
    }

    const newEntry = {
      mode: newAgreementForm.mode,
      price: parseInt(newAgreementForm.price, 10),
      zylaAgreementId: newAgreementForm.zylaAgreementId ?? "",
      agreementStartDate: new Date(
        newAgreementForm.agreementStartDate,
      ).toISOString(),
      agreementEndDate: new Date(
        newAgreementForm.agreementEndDate,
      ).toISOString(),
      agreementDocumentId: newAgreementForm.agreementDocumentId ?? null,
      externalAgreementId: newAgreementForm.externalAgreementId ?? "",
      isExternalServiceIdProvided:
        newAgreementForm.isExternalServiceIdProvided ?? false,
      externalServiceId: newAgreementForm.externalServiceId ?? "",
      externalServiceDescription:
        newAgreementForm.externalServiceDescription ?? "",
      createdAt: new Date().toISOString(),
      _isNew: true,
    };

    setLocalAgreements((prev) => [...prev, newEntry]);
    setShowAddAgreementDialog(false);
  };

  const handleOpenEditAgreementDialog = (item, index) => {
    const startDate = item?.agreementStartDate
      ? new Date(item.agreementStartDate).toISOString().split("T")[0]
      : "";
    const endDate = item?.agreementEndDate
      ? new Date(item.agreementEndDate).toISOString().split("T")[0]
      : "";
    setEditAgreementForm({
      ...item,
      price: item?.price ?? "",
      agreementStartDate: startDate,
      agreementEndDate: endDate,
      externalServiceDescription: item?.externalServiceDescription ?? "",
      comment: "",
    });
    setEditAgreementIndex(index);
    setEditAgreementPdfFile(null);
    setEditAgreementPdfUploading(false);
    setShowEditAgreementDialog(true);
  };

  const handleSaveEditAgreement = () => {
    if (editAgreementForm?.price == null || editAgreementForm?.price === "") {
      EventService.emit("showError", { message: "Please enter cost price." });
      return;
    }
    if (!editAgreementForm?.agreementStartDate) {
      EventService.emit("showError", {
        message: "Please select agreement start date.",
      });
      return;
    }
    if (!editAgreementForm?.agreementEndDate) {
      EventService.emit("showError", {
        message: "Please select agreement end date.",
      });
      return;
    }
    if (!editAgreementForm?._isNew) {
      if (
        !editAgreementForm?.comment ||
        editAgreementForm.comment.trim() === ""
      ) {
        EventService.emit("showError", {
          message: "Please enter reason for edit.",
        });
        return;
      }
    }

    const commentValue = (editAgreementForm.comment ?? "").trim();
    console.log(
      "EDIT AGREEMENT - comment from form:",
      editAgreementForm.comment,
      "trimmed:",
      commentValue,
    );

    const updatedEntry = {
      ...localAgreements[editAgreementIndex],
      price: parseInt(editAgreementForm.price, 10),
      zylaAgreementId: editAgreementForm.zylaAgreementId ?? "",
      agreementStartDate: new Date(
        editAgreementForm.agreementStartDate,
      ).toISOString(),
      agreementEndDate: new Date(
        editAgreementForm.agreementEndDate,
      ).toISOString(),
      agreementDocumentId:
        editAgreementForm.agreementDocumentId ??
        localAgreements[editAgreementIndex]?.agreementDocumentId ??
        null,
      externalAgreementId: editAgreementForm.externalAgreementId ?? "",
      isExternalServiceIdProvided:
        editAgreementForm.isExternalServiceIdProvided ?? false,
      externalServiceId: editAgreementForm.externalServiceId ?? "",
      externalServiceDescription:
        editAgreementForm.externalServiceDescription ?? "",
      comment: commentValue,
    };
    console.log("EDIT AGREEMENT - updatedEntry comment:", updatedEntry.comment);

    setLocalAgreements((prev) => {
      const updated = [...prev];
      updated[editAgreementIndex] = updatedEntry;
      return updated;
    });
    setShowEditAgreementDialog(false);
  };

  const handleViewAudit = (item) => {
    if (!item?.id) {
      EventService.emit("showError", {
        message: "No audit available for unsaved agreements.",
      });
      return;
    }
    setAuditAgreement(item);
    setAuditLoading(true);
    setAuditData([]);
    setShowAuditModal(true);
    assignServiceProviderUtil.getAgreementAudit(
      item.id,
      (res) => {
        setAuditData(
          Array.isArray(res)
            ? res
            : (res?.agreementAudits ?? res?.audits ?? []),
        );
        setAuditLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message: "Failed to fetch audit data.",
        });
        setAuditLoading(false);
      },
    );
  };

  const fetchFilteredAgreements = (page = 1, filters = agreementFilters) => {
    setAllAgreementsLoading(true);
    const body = {
      serviceId: assignedServiceProviderData?.service?.id,
      serviceProviderId: assignedServiceProviderData?.serviceProvider?.id,
      pageNum: page,
      pageSize: allAgreementsPageSize,
    };
    if (filters?.mode?.length) body.mode = filters.mode;
    if (filters?.zylaAgreementIds?.length)
      body.zylaAgreementIds = filters.zylaAgreementIds;
    if (filters?.externalServiceIds?.length)
      body.externalServiceIds = filters.externalServiceIds;
    if (filters?.externalAgreementIds?.length)
      body.externalAgreementIds = filters.externalAgreementIds;
    if (filters?.status?.length) body.status = filters.status;
    if (filters?.createdAt?.from || filters?.createdAt?.to)
      body.createdAt = filters.createdAt;
    if (filters?.agreementStartDate?.from || filters?.agreementStartDate?.to)
      body.agreementStartDate = filters.agreementStartDate;
    if (filters?.agreementEndDate?.from || filters?.agreementEndDate?.to)
      body.agreementEndDate = filters.agreementEndDate;

    assignServiceProviderUtil.getAgreementsByFilter(
      body,
      (res) => {
        setAllAgreementsData(
          res?.agreements ?? res?.agreementDetails ?? res?.data ?? [],
        );
        setAllAgreementsTotal(res?.totalCount ?? res?.total ?? 0);
        setAllAgreementsPage(page);
        setAllAgreementsLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message: "Failed to fetch agreements.",
        });
        setAllAgreementsLoading(false);
      },
    );
  };

  const handleOpenAllAgreementsModal = () => {
    setShowAllAgreementsModal(true);
    setAgreementFilters({});
    setAgreementFilterOpen(null);
    setAllAgreementsData([]);
    setAllAgreementsTotal(0);
    setAllAgreementsPage(1);
  };

  const applyAgreementFilter = (key, value) => {
    const newFilters = { ...agreementFilters, [key]: value };
    if (!value || (Array.isArray(value) && value.length === 0)) {
      delete newFilters[key];
    }
    setAgreementFilters(newFilters);
    setAgreementFilterOpen(null);
    fetchFilteredAgreements(1, newFilters);
  };

  const hasActiveFilters = (filters) => {
    return Object.keys(filters).some((k) => {
      const v = filters[k];
      if (Array.isArray(v)) return v.length > 0;
      if (v && typeof v === "object") return v.from || v.to;
      return !!v;
    });
  };

  const clearAgreementFilter = (key) => {
    const newFilters = { ...agreementFilters };
    delete newFilters[key];
    setAgreementFilters(newFilters);
    if (hasActiveFilters(newFilters)) {
      fetchFilteredAgreements(1, newFilters);
    } else {
      setAllAgreementsData([]);
      setAllAgreementsTotal(0);
      setAllAgreementsPage(1);
    }
  };

  const getAgreementDetailsSection = () => {
    const agreements = localAgreements;
    const hasAgreements = agreements && agreements.length > 0;
    const displayAgreements = hasAgreements ? agreements.slice(0, 3) : [];

    return (
      <div className="agreement-details-section">
        <div className="agreement-header">
          <span className="agreement-title">Agreement details</span>
          {props?.data?.mode != "view" && (
            <span
              className="agreement-add-more"
              style={{ cursor: "pointer" }}
              onClick={handleOpenAddAgreementDialog}
            >
              + Add more
            </span>
          )}
          <div style={{ flex: 1 }}></div>
        </div>
        {hasAgreements && (
          <>
            <div className="agreement-table-wrapper">
              <table className="agreement-table">
                <thead>
                  <tr>
                    <th>Service mode</th>
                    <th>Cost price</th>
                    <th>Creation date</th>
                    <th>Zyla agreement ID</th>
                    <th>Start date</th>
                    <th>End date</th>
                    <th>External service ID</th>
                    <th>External agreement ID</th>
                    <th>Agreement pdf</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {displayAgreements.map((item, index) => {
                    const statusInfo = getAgreementStatusLabel(item?.status);
                    return (
                      <tr key={item?.id || index}>
                        <td>{item?.mode ?? "-"}</td>
                        <td>
                          {item?.price != null ? `\u20B9${item.price}` : "-"}
                        </td>
                        <td>{formatAgreementDate(item?.createdAt)}</td>
                        <td>{item?.zylaAgreementId ?? "-"}</td>
                        <td>{formatAgreementDate(item?.agreementStartDate)}</td>
                        <td>{formatAgreementDate(item?.agreementEndDate)}</td>
                        <td>{item?.externalServiceId || "-"}</td>
                        <td>{item?.externalAgreementId ?? "-"}</td>
                        <td>
                          {item?.agreementDocumentUrl ? (
                            <span
                              className="agreement-pdf-icon"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                openPdfInNewTab(item.agreementDocumentUrl)
                              }
                            >
                              <FontIcon style={{ color: "#E44437" }}>
                                picture_as_pdf
                              </FontIcon>
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          <span className={statusInfo.className}>
                            {statusInfo.label}
                          </span>
                        </td>
                        <td>
                          <FontIcon
                            style={{
                              cursor: "pointer",
                              fontSize: "18px",
                            }}
                            onClick={(e) => {
                              const rect =
                                e.currentTarget.getBoundingClientRect();
                              setAgreementMenuPosition({
                                top: rect.bottom + 4,
                                left: rect.left - 100,
                              });
                              setAgreementMenuAnchor(e.currentTarget);
                              setAgreementMenuIndex(index);
                              setAgreementMenuItem(item);
                            }}
                          >
                            more_vert
                          </FontIcon>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {agreements.length > 3 && (
              <div
                className="agreement-view-all"
                onClick={handleOpenAllAgreementsModal}
              >
                View all agreements
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const getAllAgreementsModal = () => {
    if (!showAllAgreementsModal) return null;

    const filtersActive = hasActiveFilters(agreementFilters);
    const agreements = filtersActive ? allAgreementsData : localAgreements;
    const total = filtersActive
      ? allAgreementsTotal
      : (localAgreements?.length ?? 0);
    const totalPages = Math.ceil(total / allAgreementsPageSize);
    const currentPage = allAgreementsPage;
    const startIdx = (currentPage - 1) * allAgreementsPageSize + 1;
    const endIdx = Math.min(currentPage * allAgreementsPageSize, total);
    // Server-side: API returns the page slice. Client-side: slice locally.
    const displayAgreements = filtersActive
      ? (agreements ?? [])
      : (agreements ?? []).slice(startIdx - 1, endIdx);

    const serviceModes = serviceTypeData?.modes ?? [];
    const statusOptions = [
      { label: "Upcoming", value: 1 },
      { label: "Active", value: 2 },
      { label: "Expired", value: 3 },
      { label: "Inactive", value: 4 },
    ];

    const renderFilterIcon = (filterKey) => {
      const isActive =
        agreementFilters[filterKey] &&
        (Array.isArray(agreementFilters[filterKey])
          ? agreementFilters[filterKey].length > 0
          : agreementFilters[filterKey]?.from ||
            agreementFilters[filterKey]?.to);
      return (
        <FontIcon
          style={{
            fontSize: "14px",
            marginLeft: "4px",
            cursor: "pointer",
            color: isActive ? "#EF7C01" : "#999",
            verticalAlign: "middle",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setAgreementFilterOpen(
              agreementFilterOpen === filterKey ? null : filterKey,
            );
          }}
        >
          filter_alt
        </FontIcon>
      );
    };

    const renderFilterDropdown = (filterKey, options) => {
      if (agreementFilterOpen !== filterKey) return null;
      return (
        <div
          className="agreement-filter-dropdown"
          onClick={(e) => e.stopPropagation()}
        >
          {options.map((opt) => {
            const val = opt.value ?? opt;
            const label = opt.label ?? opt;
            const currentValues = agreementFilters[filterKey] ?? [];
            const isSelected = currentValues.includes(val);
            return (
              <div
                key={val}
                className={`agreement-filter-option ${isSelected ? "selected" : ""}`}
                onClick={() => {
                  const newValues = isSelected
                    ? currentValues.filter((v) => v !== val)
                    : [...currentValues, val];
                  applyAgreementFilter(filterKey, newValues);
                }}
              >
                <Checkbox
                  style={{ margin: 0, padding: 0, width: "auto" }}
                  checked={isSelected}
                  color="secondary"
                  onChange={() => {}}
                />
                <span style={{ marginLeft: "6px" }}>{label}</span>
              </div>
            );
          })}
          {agreementFilters[filterKey]?.length > 0 && (
            <div
              className="agreement-filter-clear"
              onClick={() => clearAgreementFilter(filterKey)}
            >
              Clear
            </div>
          )}
        </div>
      );
    };

    const renderDateFilterDropdown = (filterKey) => {
      if (agreementFilterOpen !== filterKey) return null;
      const current = agreementFilters[filterKey] ?? {};
      return (
        <div
          className="agreement-filter-dropdown date-filter"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="agreement-filter-date-row">
            <label>From</label>
            <input
              type="date"
              value={current.from ? current.from.split("T")[0] : ""}
              onChange={(e) => {
                const val = e.target.value;
                const updated = {
                  ...current,
                  from: val ? new Date(val).toISOString() : undefined,
                };
                if (updated.from && updated.to) {
                  applyAgreementFilter(filterKey, updated);
                } else {
                  setAgreementFilters((prev) => ({
                    ...prev,
                    [filterKey]: updated,
                  }));
                }
              }}
            />
          </div>
          <div className="agreement-filter-date-row">
            <label>To</label>
            <input
              type="date"
              value={current.to ? current.to.split("T")[0] : ""}
              onChange={(e) => {
                const val = e.target.value;
                const updated = {
                  ...current,
                  to: val ? new Date(val).toISOString() : undefined,
                };
                if (updated.from && updated.to) {
                  applyAgreementFilter(filterKey, updated);
                } else {
                  setAgreementFilters((prev) => ({
                    ...prev,
                    [filterKey]: updated,
                  }));
                }
              }}
            />
          </div>
          {(current.from || current.to) && (
            <div
              className="agreement-filter-clear"
              onClick={() => clearAgreementFilter(filterKey)}
            >
              Clear
            </div>
          )}
        </div>
      );
    };

    const renderTextFilterDropdown = (filterKey) => {
      if (agreementFilterOpen !== filterKey) return null;
      const currentValues = agreementFilters[filterKey] ?? [];
      return (
        <div
          className="agreement-filter-dropdown text-filter"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="agreement-filter-text-row">
            <input
              type="text"
              placeholder="Type to search"
              className="agreement-filter-text-input"
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.value.trim()) {
                  applyAgreementFilter(filterKey, [
                    ...currentValues,
                    e.target.value.trim(),
                  ]);
                  e.target.value = "";
                }
              }}
            />
            <FontIcon
              className="agreement-filter-search-btn"
              onClick={() => {
                const input = document.querySelector(
                  `.agreement-filter-dropdown.text-filter .agreement-filter-text-input`,
                );
                if (input && input.value.trim()) {
                  applyAgreementFilter(filterKey, [
                    ...currentValues,
                    input.value.trim(),
                  ]);
                  input.value = "";
                }
              }}
            >
              arrow_forward
            </FontIcon>
          </div>
          {currentValues.map((val, i) => (
            <div key={i} className="agreement-filter-chip">
              <span>{val}</span>
              <FontIcon
                style={{
                  fontSize: "14px",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
                onClick={() =>
                  applyAgreementFilter(
                    filterKey,
                    currentValues.filter((_, idx) => idx !== i),
                  )
                }
              >
                close
              </FontIcon>
            </div>
          ))}
          {currentValues.length > 0 && (
            <div
              className="agreement-filter-clear"
              onClick={() => clearAgreementFilter(filterKey)}
            >
              Clear
            </div>
          )}
        </div>
      );
    };

    return (
      <DialogContainer
        id="all-agreements-modal"
        visible={showAllAgreementsModal}
        focusOnMount={false}
        onHide={() => {
          setShowAllAgreementsModal(false);
          setAgreementFilterOpen(null);
        }}
        width="95%"
        autosizeContent
        height="auto"
        style={{ textAlign: "left", zIndex: 200 }}
        dialogStyle={{
          borderRadius: "10px",
          position: "relative",
          maxWidth: "1400px",
        }}
      >
        <div className="all-agreements-modal-content">
          <div className="all-agreements-modal-header">
            <h3>All agreements</h3>
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div className="agreement-pagination">
                <FontIcon
                  style={{
                    fontSize: "18px",
                    cursor: allAgreementsPage > 1 ? "pointer" : "not-allowed",
                    color: allAgreementsPage > 1 ? "#333" : "#ccc",
                  }}
                  onClick={() => {
                    if (allAgreementsPage > 1) {
                      const newPage = allAgreementsPage - 1;
                      if (filtersActive) {
                        fetchFilteredAgreements(newPage);
                      } else {
                        setAllAgreementsPage(newPage);
                      }
                    }
                  }}
                >
                  chevron_left
                </FontIcon>
                <span className="agreement-pagination-text">
                  Showing {total > 0 ? startIdx : 0}-{endIdx} of {total}
                </span>
                <FontIcon
                  style={{
                    fontSize: "18px",
                    cursor:
                      allAgreementsPage < totalPages
                        ? "pointer"
                        : "not-allowed",
                    color: allAgreementsPage < totalPages ? "#333" : "#ccc",
                  }}
                  onClick={() => {
                    if (allAgreementsPage < totalPages) {
                      const newPage = allAgreementsPage + 1;
                      if (filtersActive) {
                        fetchFilteredAgreements(newPage);
                      } else {
                        setAllAgreementsPage(newPage);
                      }
                    }
                  }}
                >
                  chevron_right
                </FontIcon>
              </div>
              <FontIcon
                style={{ cursor: "pointer", fontSize: "24px" }}
                onClick={() => {
                  setShowAllAgreementsModal(false);
                  setAgreementFilterOpen(null);
                }}
              >
                close
              </FontIcon>
            </div>
          </div>
          {allAgreementsLoading ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              Loading...
            </div>
          ) : (
            <div
              className="agreement-table-wrapper"
              style={{
                maxHeight: "500px",
                minHeight: "300px",
                overflowY: "auto",
              }}
            >
              <table className="agreement-table">
                <thead>
                  <tr>
                    <th style={{ position: "relative" }}>
                      Service mode {renderFilterIcon("mode")}
                      {renderFilterDropdown("mode", serviceModes)}
                    </th>
                    <th>Cost price</th>
                    <th style={{ position: "relative" }}>
                      Creation date {renderFilterIcon("createdAt")}
                      {renderDateFilterDropdown("createdAt")}
                    </th>
                    <th style={{ position: "relative" }}>
                      Zyla agreement ID {renderFilterIcon("zylaAgreementIds")}
                      {renderTextFilterDropdown("zylaAgreementIds")}
                    </th>
                    <th style={{ position: "relative" }}>
                      Start date {renderFilterIcon("agreementStartDate")}
                      {renderDateFilterDropdown("agreementStartDate")}
                    </th>
                    <th style={{ position: "relative" }}>
                      End date {renderFilterIcon("agreementEndDate")}
                      {renderDateFilterDropdown("agreementEndDate")}
                    </th>
                    <th style={{ position: "relative" }}>
                      External service ID{" "}
                      {renderFilterIcon("externalServiceIds")}
                      {renderTextFilterDropdown("externalServiceIds")}
                    </th>
                    <th style={{ position: "relative" }}>
                      External agreement ID{" "}
                      {renderFilterIcon("externalAgreementIds")}
                      {renderTextFilterDropdown("externalAgreementIds")}
                    </th>
                    <th>Agreement pdf</th>
                    <th style={{ position: "relative" }}>
                      Status {renderFilterIcon("status")}
                      {renderFilterDropdown("status", statusOptions)}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {displayAgreements.length === 0 ? (
                    <tr>
                      <td
                        colSpan={11}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No agreements found.
                      </td>
                    </tr>
                  ) : (
                    displayAgreements.map((item, index) => {
                      const statusInfo = getAgreementStatusLabel(item?.status);
                      return (
                        <tr key={item?.id || index}>
                          <td>{item?.mode ?? "-"}</td>
                          <td>
                            {item?.price != null ? `\u20B9${item.price}` : "-"}
                          </td>
                          <td>{formatAgreementDate(item?.createdAt)}</td>
                          <td>{item?.zylaAgreementId ?? "-"}</td>
                          <td>
                            {formatAgreementDate(item?.agreementStartDate)}
                          </td>
                          <td>{formatAgreementDate(item?.agreementEndDate)}</td>
                          <td>{item?.externalServiceId || "-"}</td>
                          <td>{item?.externalAgreementId ?? "-"}</td>
                          <td>
                            {item?.agreementDocumentUrl ? (
                              <span
                                className="agreement-pdf-icon"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  openPdfInNewTab(item.agreementDocumentUrl)
                                }
                              >
                                <FontIcon style={{ color: "#E44437" }}>
                                  picture_as_pdf
                                </FontIcon>
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <span className={statusInfo.className}>
                              {statusInfo.label}
                            </span>
                          </td>
                          <td>
                            <FontIcon
                              style={{
                                cursor: "pointer",
                                fontSize: "18px",
                              }}
                              onClick={(e) => {
                                const rect =
                                  e.currentTarget.getBoundingClientRect();
                                setAgreementMenuPosition({
                                  top: rect.bottom + 4,
                                  left: rect.left - 100,
                                });
                                setAgreementMenuAnchor(e.currentTarget);
                                setAgreementMenuIndex(`modal-${index}`);
                                setAgreementMenuItem(item);
                              }}
                            >
                              more_vert
                            </FontIcon>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </DialogContainer>
    );
  };

  const getAddAgreementDialog = () => {
    const serviceModes = serviceTypeData?.modes ?? [];

    return (
      <DialogContainer
        id="add-agreement-dialog"
        visible={showAddAgreementDialog}
        focusOnMount={false}
        onHide={() => setShowAddAgreementDialog(false)}
        width="750px"
        autosizeContent
        height="auto"
        style={{ textAlign: "left", zIndex: 200 }}
        dialogStyle={{
          borderRadius: "10px",
          position: "relative",
          maxWidth: "750px",
        }}
      >
        <div className="add-agreement-dialog-content">
          <div className="add-agreement-dialog-header">
            <h3>Add agreement ID</h3>
            <FontIcon
              style={{ cursor: "pointer", fontSize: "24px" }}
              onClick={() => setShowAddAgreementDialog(false)}
            >
              close
            </FontIcon>
          </div>

          <Row>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Select service mode`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div>
                  <SelectField
                    id="agreementMode"
                    name="agreementMode"
                    menuItems={serviceModes}
                    placeholder="Select"
                    fullWidth
                    onChange={(e) =>
                      setNewAgreementForm((prev) => ({ ...prev, mode: e }))
                    }
                    value={newAgreementForm?.mode ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Cost price`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div>
                  <TextField
                    id="agreementPrice"
                    name="agreementPrice"
                    type="number"
                    placeholder="-"
                    onChange={(e) =>
                      setNewAgreementForm((prev) => ({ ...prev, price: e }))
                    }
                    value={newAgreementForm?.price ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">{`Zyla agreement ID`}</div>
                <div>
                  <TextField
                    id="zylaAgreementId"
                    name="zylaAgreementId"
                    type="text"
                    placeholder="-"
                    onChange={(e) =>
                      setNewAgreementForm((prev) => ({
                        ...prev,
                        zylaAgreementId: e,
                      }))
                    }
                    value={newAgreementForm?.zylaAgreementId ?? ""}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Agreement start date`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div>
                  <TextField
                    id="agreementStartDate"
                    name="agreementStartDate"
                    type="date"
                    placeholder="-"
                    onChange={(e) =>
                      setNewAgreementForm((prev) => ({
                        ...prev,
                        agreementStartDate: e,
                      }))
                    }
                    value={newAgreementForm?.agreementStartDate ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Agreement end date`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div>
                  <TextField
                    id="agreementEndDate"
                    name="agreementEndDate"
                    type="date"
                    placeholder="-"
                    onChange={(e) =>
                      setNewAgreementForm((prev) => ({
                        ...prev,
                        agreementEndDate: e,
                      }))
                    }
                    value={newAgreementForm?.agreementEndDate ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">{`Agreement pdf (Max file size : 20 mb)`}</div>
                <div className="agreement-pdf-upload-container">
                  <label
                    htmlFor="agreement-pdf-upload-input"
                    className="agreement-pdf-upload-label"
                  >
                    {agreementPdfFile
                      ? agreementPdfFile.name
                      : agreementPdfUploading
                        ? "Uploading..."
                        : "Upload pdf"}
                    <FontIcon style={{ fontSize: "18px", marginLeft: "8px" }}>
                      file_upload
                    </FontIcon>
                  </label>
                  <input
                    id="agreement-pdf-upload-input"
                    type="file"
                    accept=".pdf"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      if (file.size > 20 * 1024 * 1024) {
                        EventService.emit("showError", {
                          message: "File size exceeds 20 MB limit.",
                        });
                        return;
                      }
                      setAgreementPdfFile(file);
                      setAgreementPdfUploading(true);
                      uploadAgreementPdf(file)
                        .then((res) => {
                          setNewAgreementForm((prev) => ({
                            ...prev,
                            agreementDocumentId: res?.id ?? null,
                          }));
                          setAgreementPdfUploading(false);
                        })
                        .catch((err) => {
                          EventService.emit("showError", {
                            message: `Error uploading PDF: ${err?.message ?? err}`,
                          });
                          setAgreementPdfUploading(false);
                        });
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">{`External agreement ID`}</div>
                <div>
                  <TextField
                    id="externalAgreementId"
                    name="externalAgreementId"
                    type="text"
                    placeholder="-"
                    onChange={(e) =>
                      setNewAgreementForm((prev) => ({
                        ...prev,
                        externalAgreementId: e,
                      }))
                    }
                    value={newAgreementForm?.externalAgreementId ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={8} md={8} lg={8}>
              <div
                className="mp-field-container"
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "20px",
                }}
              >
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={
                    newAgreementForm?.isExternalServiceIdProvided ?? false
                  }
                  color="secondary"
                  onChange={(e) =>
                    setNewAgreementForm((prev) => ({
                      ...prev,
                      isExternalServiceIdProvided: e.target.checked,
                    }))
                  }
                />
                <span className="mp-label" style={{ marginBottom: 0 }}>
                  External service ID
                </span>
                <TextField
                  id="agreementExternalServiceId"
                  name="agreementExternalServiceId"
                  type="text"
                  placeholder="-"
                  disabled={!newAgreementForm?.isExternalServiceIdProvided}
                  onChange={(e) =>
                    setNewAgreementForm((prev) => ({
                      ...prev,
                      externalServiceId: e,
                    }))
                  }
                  value={newAgreementForm?.externalServiceId ?? ""}
                  style={{ flex: 1 }}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="mp-field-container">
                <div className="mp-label">{`External service description`}</div>
                <div>
                  <TextField
                    id="addAgreementExtServiceDesc"
                    name="addAgreementExtServiceDesc"
                    type="text"
                    placeholder="Type here..."
                    onChange={(e) =>
                      setNewAgreementForm((prev) => ({
                        ...prev,
                        externalServiceDescription: e,
                      }))
                    }
                    value={newAgreementForm?.externalServiceDescription ?? ""}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              raised
              secondary
              className="agreement-dialog-save-btn"
              onClick={handleSaveNewAgreement}
              disabled={agreementPdfUploading}
            >
              Save
            </Button>
          </div>
        </div>
      </DialogContainer>
    );
  };

  const getEditAgreementDialog = () => {
    return (
      <DialogContainer
        id="edit-agreement-dialog"
        visible={showEditAgreementDialog}
        focusOnMount={false}
        onHide={() => setShowEditAgreementDialog(false)}
        width="750px"
        autosizeContent
        height="auto"
        style={{ textAlign: "left", zIndex: 200 }}
        dialogStyle={{
          borderRadius: "10px",
          position: "relative",
          maxWidth: "750px",
        }}
      >
        <div className="add-agreement-dialog-content">
          <div className="add-agreement-dialog-header">
            <h3>Edit agreement ID</h3>
            <FontIcon
              style={{ cursor: "pointer", fontSize: "24px" }}
              onClick={() => setShowEditAgreementDialog(false)}
            >
              close
            </FontIcon>
          </div>

          <Row>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Select service mode`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div>
                  <TextField
                    id="editAgreementMode"
                    name="editAgreementMode"
                    type="text"
                    disabled
                    value={editAgreementForm?.mode ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Cost price`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div>
                  <TextField
                    id="editAgreementPrice"
                    name="editAgreementPrice"
                    type="number"
                    placeholder="-"
                    onChange={(e) =>
                      setEditAgreementForm((prev) => ({ ...prev, price: e }))
                    }
                    value={editAgreementForm?.price ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">{`Zyla agreement ID`}</div>
                <div>
                  <TextField
                    id="editZylaAgreementId"
                    name="editZylaAgreementId"
                    type="text"
                    placeholder="-"
                    onChange={(e) =>
                      setEditAgreementForm((prev) => ({
                        ...prev,
                        zylaAgreementId: e,
                      }))
                    }
                    value={editAgreementForm?.zylaAgreementId ?? ""}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Agreement start date`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div>
                  <TextField
                    id="editAgreementStartDate"
                    name="editAgreementStartDate"
                    type="date"
                    placeholder="-"
                    onChange={(e) =>
                      setEditAgreementForm((prev) => ({
                        ...prev,
                        agreementStartDate: e,
                      }))
                    }
                    value={editAgreementForm?.agreementStartDate ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">
                  {`Agreement end date`}
                  <label className="mp-label-red"> *</label>
                </div>
                <div>
                  <TextField
                    id="editAgreementEndDate"
                    name="editAgreementEndDate"
                    type="date"
                    placeholder="-"
                    onChange={(e) =>
                      setEditAgreementForm((prev) => ({
                        ...prev,
                        agreementEndDate: e,
                      }))
                    }
                    value={editAgreementForm?.agreementEndDate ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">{`Agreement pdf (Max file size : 20 mb)`}</div>
                <div className="agreement-pdf-upload-container">
                  <label
                    htmlFor="edit-agreement-pdf-upload-input"
                    className="agreement-pdf-upload-label"
                  >
                    {editAgreementPdfFile
                      ? editAgreementPdfFile.name
                      : editAgreementPdfUploading
                        ? "Uploading..."
                        : editAgreementForm?.agreementDocumentId
                          ? "PDF uploaded"
                          : "Upload pdf"}
                    <FontIcon style={{ fontSize: "18px", marginLeft: "8px" }}>
                      file_upload
                    </FontIcon>
                  </label>
                  <input
                    id="edit-agreement-pdf-upload-input"
                    type="file"
                    accept=".pdf"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      if (file.size > 20 * 1024 * 1024) {
                        EventService.emit("showError", {
                          message: "File size exceeds 20 MB limit.",
                        });
                        return;
                      }
                      setEditAgreementPdfFile(file);
                      setEditAgreementPdfUploading(true);
                      uploadAgreementPdf(file)
                        .then((res) => {
                          setEditAgreementForm((prev) => ({
                            ...prev,
                            agreementDocumentId: res?.id ?? null,
                          }));
                          setEditAgreementPdfUploading(false);
                        })
                        .catch((err) => {
                          EventService.emit("showError", {
                            message: `Error uploading PDF: ${err?.message ?? err}`,
                          });
                          setEditAgreementPdfUploading(false);
                        });
                    }}
                  />
                  {editAgreementForm?.agreementDocumentUrl && (
                    <span
                      style={{ marginLeft: "8px", cursor: "pointer" }}
                      onClick={() =>
                        openPdfInNewTab(editAgreementForm.agreementDocumentUrl)
                      }
                    >
                      <FontIcon style={{ color: "#4CAF50", fontSize: "18px" }}>
                        check_circle
                      </FontIcon>
                      <FontIcon
                        style={{
                          color: "#2196F3",
                          fontSize: "18px",
                          marginLeft: "4px",
                        }}
                      >
                        file_download
                      </FontIcon>
                    </span>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={4} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">{`External agreement ID`}</div>
                <div>
                  <TextField
                    id="editExternalAgreementId"
                    name="editExternalAgreementId"
                    type="text"
                    placeholder="-"
                    onChange={(e) =>
                      setEditAgreementForm((prev) => ({
                        ...prev,
                        externalAgreementId: e,
                      }))
                    }
                    value={editAgreementForm?.externalAgreementId ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={8} md={8} lg={8}>
              <div
                className="mp-field-container"
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "20px",
                }}
              >
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={
                    editAgreementForm?.isExternalServiceIdProvided ?? false
                  }
                  color="secondary"
                  onChange={(e) =>
                    setEditAgreementForm((prev) => ({
                      ...prev,
                      isExternalServiceIdProvided: e.target.checked,
                    }))
                  }
                />
                <span className="mp-label" style={{ marginBottom: 0 }}>
                  External service ID
                </span>
                <TextField
                  id="editAgreementExternalServiceId"
                  name="editAgreementExternalServiceId"
                  type="text"
                  placeholder="-"
                  disabled={!editAgreementForm?.isExternalServiceIdProvided}
                  onChange={(e) =>
                    setEditAgreementForm((prev) => ({
                      ...prev,
                      externalServiceId: e,
                    }))
                  }
                  value={editAgreementForm?.externalServiceId ?? ""}
                  style={{ flex: 1 }}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="mp-field-container">
                <div className="mp-label">{`External service description`}</div>
                <div>
                  <TextField
                    id="editAgreementExtServiceDesc"
                    name="editAgreementExtServiceDesc"
                    type="text"
                    placeholder="Type here..."
                    onChange={(e) =>
                      setEditAgreementForm((prev) => ({
                        ...prev,
                        externalServiceDescription: e,
                      }))
                    }
                    value={editAgreementForm?.externalServiceDescription ?? ""}
                  />
                </div>
              </div>
            </Col>
          </Row>

          {!editAgreementForm?._isNew && (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="mp-field-container">
                  <div className="mp-label">
                    {`Reason for edit`}
                    <label className="mp-label-red"> *</label>
                  </div>
                  <div>
                    <TextField
                      id="editAgreementComment"
                      name="editAgreementComment"
                      type="text"
                      placeholder="Enter reason for edit"
                      onChange={(e) =>
                        setEditAgreementForm((prev) => ({
                          ...prev,
                          comment: e,
                        }))
                      }
                      value={editAgreementForm?.comment ?? ""}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              raised
              secondary
              className="agreement-dialog-save-btn"
              onClick={handleSaveEditAgreement}
              disabled={editAgreementPdfUploading}
            >
              Save
            </Button>
          </div>
        </div>
      </DialogContainer>
    );
  };

  const getViewAuditModal = () => {
    if (!showAuditModal || !auditAgreement) return null;

    return (
      <DialogContainer
        id="view-audit-modal"
        visible={showAuditModal}
        focusOnMount={false}
        onHide={() => setShowAuditModal(false)}
        width="90%"
        autosizeContent
        height="auto"
        style={{ textAlign: "left", zIndex: 200 }}
        dialogStyle={{
          borderRadius: "10px",
          position: "relative",
          maxWidth: "1100px",
        }}
      >
        <div className="audit-modal-content">
          <div className="audit-modal-header">
            <h3>View audits</h3>
            <FontIcon
              style={{ cursor: "pointer", fontSize: "24px" }}
              onClick={() => setShowAuditModal(false)}
            >
              close
            </FontIcon>
          </div>

          <div className="audit-agreement-info">
            <div className="audit-info-row">
              <div className="audit-info-item">
                <span className="audit-info-label">Service mode</span>
                <span className="audit-info-value">
                  {auditAgreement?.mode ?? "-"}
                </span>
              </div>
              <div className="audit-info-item">
                <span className="audit-info-label">Cost price</span>
                <span className="audit-info-value">
                  {auditAgreement?.price != null
                    ? `\u20B9${auditAgreement.price}`
                    : "-"}
                </span>
              </div>
              <div className="audit-info-item">
                <span className="audit-info-label">Creation date</span>
                <span className="audit-info-value">
                  {formatAgreementDate(auditAgreement?.createdAt)}
                </span>
              </div>
              <div className="audit-info-item">
                <span className="audit-info-label">Agreement start date</span>
                <span className="audit-info-value">
                  {formatAgreementDate(auditAgreement?.agreementStartDate)}
                </span>
              </div>
              <div className="audit-info-item">
                <span className="audit-info-label">Agreement end date</span>
                <span className="audit-info-value">
                  {formatAgreementDate(auditAgreement?.agreementEndDate)}
                </span>
              </div>
            </div>
            <div className="audit-info-row">
              <div className="audit-info-item">
                <span className="audit-info-label">Zyla agreement ID</span>
                <span className="audit-info-value">
                  {auditAgreement?.zylaAgreementId ?? "-"}
                </span>
              </div>
              <div className="audit-info-item">
                <span className="audit-info-label">External agreement ID</span>
                <span className="audit-info-value">
                  {auditAgreement?.externalAgreementId ?? "-"}
                </span>
              </div>
              <div className="audit-info-item">
                <span className="audit-info-label">External service ID</span>
                <span className="audit-info-value">
                  {auditAgreement?.externalServiceId || "-"}
                </span>
              </div>
              <div className="audit-info-item">
                <span className="audit-info-label">Agreement pdf</span>
                <span className="audit-info-value">
                  {auditAgreement?.agreementDocumentUrl ? (
                    <span
                      style={{ cursor: "pointer", color: "#E44437" }}
                      onClick={() =>
                        openPdfInNewTab(auditAgreement.agreementDocumentUrl)
                      }
                    >
                      Agreement pdf
                    </span>
                  ) : (
                    "-"
                  )}
                </span>
              </div>
            </div>
            {auditAgreement?.externalServiceDescription && (
              <div className="audit-info-row">
                <div className="audit-info-item" style={{ flex: "1 1 100%" }}>
                  <span className="audit-info-label">
                    External service description
                  </span>
                  <span
                    className="audit-info-value"
                    dangerouslySetInnerHTML={{
                      __html: auditAgreement.externalServiceDescription,
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          {auditLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              Loading...
            </div>
          ) : (
            <div
              className="audit-table-wrapper"
              style={{ maxHeight: "300px", overflowY: "auto" }}
            >
              <table className="audit-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Updated field</th>
                    <th>Previous</th>
                    <th>New</th>
                    <th>Updated by</th>
                    <th>Updated on</th>
                    <th>Comment</th>
                  </tr>
                </thead>
                <tbody>
                  {auditData.length === 0 ? (
                    <tr>
                      <td
                        colSpan={7}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No audit records found.
                      </td>
                    </tr>
                  ) : (
                    auditData.map((audit, idx) => {
                      const fieldKey =
                        audit?.updatedField ?? audit?.fieldName ?? "";
                      const fieldLabelMap = {
                        mode: "Service mode",
                        price: "Cost price",
                        agreementStartDate: "Agreement start date",
                        agreementEndDate: "Agreement end date",
                        agreementDocumentId: "Agreement pdf",
                        externalAgreementId: "External agreement ID",
                        externalServiceId: "External service ID",
                        externalServiceDescription:
                          "External service description",
                        zylaAgreementId: "Zyla agreement ID",
                        isExternalServiceIdProvided:
                          "External service ID provided",
                        comment: "Comment",
                      };
                      const fieldLabel =
                        fieldLabelMap[fieldKey] ||
                        fieldKey
                          .replace(/([A-Z])/g, " $1")
                          .replace(/^./, (s) => s.toUpperCase());

                      const isDateField = [
                        "agreementStartDate",
                        "agreementEndDate",
                        "createdAt",
                        "updatedAt",
                      ].includes(fieldKey);
                      const isPdfField = fieldKey === "agreementDocumentId";
                      const isPriceField = fieldKey === "price";

                      const formatAuditValue = (val) => {
                        if (val == null || val === "") return "-";
                        if (isDateField) return formatAgreementDate(val);
                        if (isPriceField) return `\u20B9${val}`;
                        return String(val);
                      };

                      const renderAuditValue = (val, label) => {
                        if (isPdfField && val) {
                          return (
                            <span
                              style={{
                                cursor: "pointer",
                                color: "#E44437",
                                textDecoration: "underline",
                              }}
                              onClick={() => openPdfInNewTab(val)}
                            >
                              {label || "Agreement pdf"}
                            </span>
                          );
                        }
                        return formatAuditValue(val);
                      };

                      return (
                        <tr key={idx}>
                          <td>{idx + 1}.</td>
                          <td>{fieldLabel}</td>
                          <td>
                            {isPdfField
                              ? renderAuditValue(
                                  audit?.previousValue ?? audit?.previous,
                                  "Agreement pdf old",
                                )
                              : formatAuditValue(
                                  audit?.previousValue ?? audit?.previous,
                                )}
                          </td>
                          <td>
                            {isPdfField
                              ? renderAuditValue(
                                  audit?.newValue ?? audit?.new,
                                  "Agreement pdf new",
                                )
                              : formatAuditValue(audit?.newValue ?? audit?.new)}
                          </td>
                          <td>{audit?.updatedBy ?? "-"}</td>
                          <td>
                            {formatAgreementDate(
                              audit?.updatedOn ?? audit?.updatedAt,
                            )}
                          </td>
                          <td>{audit?.comment ?? "-"}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </DialogContainer>
    );
  };

  const resetAddOrUpdateCities = () => {
    setTableDataEditAudits({});
  };

  const getServiceDetailsSection = () => {
    return (
      <div className="service-details-container">
        <Row>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service ID`}</div>
              <div>
                <TextField
                  id="serviceId"
                  name="serviceId"
                  type="text"
                  // leftIcon={<FontIcon>assignment</FontIcon>}
                  disabled
                  value={assignedServiceProviderData?.service?.id}
                  // error={ this.state.error.description ? true : false }
                  // errorText={ this.state.error.description }
                  // onChange={ this._syncState }
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service`}</div>
              <div>
                <TextField
                  id="service"
                  name="service"
                  type="text"
                  disabled
                  value={assignedServiceProviderData?.service?.name}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service name`}</div>
              <div>
                <TextField
                  id="serviceName"
                  name="serviceName"
                  type="text"
                  disabled
                  value={assignedServiceProviderData?.service?.serviceName}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service type`}</div>
              <div>
                <TextField
                  id="serviceType"
                  name="serviceType"
                  type="text"
                  disabled
                  value={assignedServiceProviderData?.service?.serviceTypeName}
                />
              </div>
            </div>
          </Col>
          {assignedServiceProviderData?.service?.serviceSubtypeId !== 0 && (
            <Col xs={12} sm={5} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">{`Service subtype`}</div>
                <div>
                  <TextField
                    id="serviceSubtype"
                    name="serviceSubtype"
                    type="text"
                    disabled
                    value={
                      assignedServiceProviderData?.service?.serviceSubtypeName
                    }
                  />
                </div>
              </div>
            </Col>
          )}
        </Row>
      </div>
    );
  };

  const returnTableDataWithEditsAppliedWithOnlyEditedEntities = (
    cityMappings,
    tableDataEditAudits,
  ) => {
    return mergeUpdatesWithOnlyEditedEntities(
      cityMappings?.cityEntities ?? [],
      tableDataEditAudits,
    );
  };

  const mergeUpdatesWithOnlyEditedEntities = (data, audits) => {
    // removing Deleted & entities with no change
    const finalCityMappings = (Object.values(audits ?? {}) ?? [])?.filter(
      (item) =>
        item?.status !== item?.originalEntity?.status ||
        item?.price !== item?.originalEntity?.price,
    );
    return finalCityMappings;
  };

  let updateSPCityToPriceMapping = (syncLevels = false) => {
    setLoading(true);
    let onResponse = (res) => {
      setLoading(false);
      if ((res?.totalErrors ?? 0) > 0) {
        setErrorObject((prev) => ({
          operation: 2,
          errorResponse: res?.errorResponse,
          totalRequested: res?.totalRequested,
          totalErrors: res?.totalErrors,
        }));
        EventService.emit("showError", {
          message: `City mappings updated partially with ${
            res?.totalErrors ?? 0
          } errors`,
        });
      } else {
        EventService.emit("showError", {
          message: `City mappings updated successfully`,
        });
      }
      setTableDataEditAudits((prev) => {});
      fetchCityMappings(
        assignedServiceProviderData?.service?.id,
        assignedServiceProviderData?.serviceProvider?.id,
        1,
        {},
      );
    };
    let onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    assignServiceProviderUtil.updateSPCityToPriceMapping(
      {
        serviceId: assignedServiceProviderData?.service?.id,
        serviceProviderId: assignedServiceProviderData?.serviceProvider?.id,
        syncLevels: syncLevels,
        cityEntities: (
          returnTableDataWithEditsAppliedWithOnlyEditedEntities(
            cityMappings ?? {},
            tableDataEditAudits ?? {},
          ) ?? []
        ).map(({ id, serviceProviderAssignCityId, price, status }) => ({
          cityId: (serviceProviderAssignCityId ?? "") == "" ? id : null,
          serviceProviderAssignCityId,
          price,
          status,
        })),
      },
      onResponse,
      onError,
    );
  };

  let checkIfThereIsAnythingToUpdate = () => {
    return (
      cityMappingOperationSelected === 2 &&
      (
        returnTableDataWithEditsAppliedWithOnlyEditedEntities(
          cityMappings ?? {},
          tableDataEditAudits ?? {},
        ) ?? []
      ).length > 0
    );
  };

  const toggleExpansionPanelExpandedState = (row, newVal) => {
    setIsExpansionPanelExpanded((prev) => ({
      ...prev,
      [row]: newVal ?? !prev?.[row],
    }));
  };

  const exitPage = () => {
    setServiceTypeData({});
    setAssignedServiceProviderData({});
    setAssignedServiceProviderModesData({});
    setSPbodyToUpdate(null);
    setOpenPropCalendarChangesDialog(false);
    props.setView(3, {
      mode: "assign",
      serviceId: props?.data?.service?.id,
    });
    setShowUpdateCityMappingNowDialog(false);
  };

  const scrollToPricePerCityHeading = () => {
    requestAnimationFrame(() => {
      if (enablePricePerCityTextRef?.current) {
        enablePricePerCityTextRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });
  };

  const getServiceModesSection = () => {
    return (
      <ExpansionList>
        {serviceTypeData?.modes?.map((row, index) => (
          <ExpansionPanel
            expanded={isExpansionPanelExpanded?.[row] ?? false}
            onExpandToggle={(isExpanded) => {
              if (isExpanded) {
                if (assignedServiceProviderModesData?.[row]?.enabled)
                  toggleExpansionPanelExpandedState(row?.toString() ?? "");
              } else {
                toggleExpansionPanelExpandedState(row?.toString() ?? "");
              }
            }}
            key={index}
            style={{
              borderRadius: "8px",
              backgroundColor: "#CED4DA",
              marginLeft: "30px",
              marginRight: "30px",
              marginBottom: "20px",
            }}
            label={
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={assignedServiceProviderModesData?.[row]?.enabled}
                  color="secondary"
                  disabled={props?.data?.mode == "view"}
                  onChange={(e) => {
                    e.stopPropagation();
                    if (e.target.checked) {
                      toggleExpansionPanelExpandedState(
                        row?.toString() ?? "",
                        true,
                      );
                    } else {
                      toggleExpansionPanelExpandedState(
                        row?.toString() ?? "",
                        false,
                      );
                    }
                    updateAssignedServiceProviderModesDataField(
                      row.toString(),
                      "enabled",
                      e.target.checked,
                    );
                    if (e.target.checked) {
                      updateAssignedServiceProviderModesDataField(
                        row.toString(),
                        "availability",
                        assignedServiceProviderData?.serviceProvider
                          ?.serviceTypeId == 5
                          ? (assignedServiceProviderData?.serviceProvider
                              ?.dentalInfo?.availability ?? EMPTY_CALENDAR)
                          : assignedServiceProviderData?.serviceProvider
                                ?.serviceTypeId == 3
                            ? (assignedServiceProviderData?.serviceProvider
                                ?.vaccineInfo?.availability ?? EMPTY_CALENDAR)
                            : assignedServiceProviderData?.serviceProvider
                                  ?.serviceTypeId == 2
                              ? (assignedServiceProviderData?.serviceProvider
                                  ?.checkupInfo?.availability ?? EMPTY_CALENDAR)
                              : (assignedServiceProviderData?.serviceProvider
                                  ?.consultationInfo?.availability ??
                                EMPTY_CALENDAR ??
                                EMPTY_CALENDAR),
                      );
                    }
                  }}
                />
                <div style={{ width: "10px" }}></div>
                <div style={{ fontWeight: 700 }}>{row ? row : "None"}</div>
              </div>
            }
            expandedSecondaryLabel={null}
            footer={null}
            headerStyle={{
              margin: 0,
              padding: 0,
              marginLeft: 20,
              marginRight: 20,
            }}
            contentClassName="expansion-list-content-class"
            children={
              assignedServiceProviderModesData?.[row]?.enabled && (
                <div
                  style={{
                    backgroundColor: "white",
                    paddingRight: "20px",
                    paddingLeft: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <Row>
                    <Col xs={12} sm={5} md={4} lg={4}>
                      <div className="mp-field-container">
                        <div className="mp-label">
                          {`Cost price`}
                          <label className="mp-label-red"> *</label>
                        </div>
                        <div>
                          <TextField
                            id="price"
                            name="price"
                            type="number"
                            placeholder="Type here"
                            disabled={props?.data?.mode == "view"}
                            onChange={(e) =>
                              updateAssignedServiceProviderModesDataField(
                                row.toString(),
                                "price",
                                stringToInt(e),
                              )
                            }
                            value={
                              assignedServiceProviderModesData?.[row]?.price
                            }
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={5} md={4} lg={4}>
                      <div className="mp-field-container">
                        <div className="mp-label">{`MRP`}</div>
                        <div>
                          <TextField
                            id="maxRetailPrice"
                            name="maxRetailPrice"
                            type="number"
                            placeholder="Type here"
                            disabled={props?.data?.mode == "view"}
                            onChange={(e) =>
                              updateAssignedServiceProviderModesDataField(
                                row.toString(),
                                "maxRetailPrice",
                                stringToInt(e),
                              )
                            }
                            value={
                              assignedServiceProviderModesData?.[row]
                                ?.maxRetailPrice
                            }
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={5} md={4} lg={4}>
                      <div className="mp-field-container">
                        <div className="mp-label">{`Discounted price`}</div>
                        <div>
                          <TextField
                            id="discountedPrice"
                            name="discountedPrice"
                            type="number"
                            placeholder="Type here"
                            disabled={props?.data?.mode == "view"}
                            onChange={(e) =>
                              updateAssignedServiceProviderModesDataField(
                                row.toString(),
                                "discountedPrice",
                                stringToInt(e),
                              )
                            }
                            value={
                              assignedServiceProviderModesData?.[row]
                                ?.discountedPrice
                            }
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={5} md={4} lg={4}>
                      <div className="mp-field-container">
                        <div className="mp-label">
                          {`Mode status`}
                          <label className="mp-label-red"> *</label>
                        </div>
                        <div>
                          <SelectField
                            id="modeStatus"
                            name="modeStatus"
                            menuItems={["Active", "Inactive"]}
                            placeholder="Select"
                            fullWidth
                            disabled={props?.data?.mode == "view"}
                            onChange={(e) =>
                              updateAssignedServiceProviderModesDataField(
                                row.toString(),
                                "modeStatus",
                                e === "Active" ? true : false,
                              )
                            }
                            value={
                              assignedServiceProviderModesData?.[row]
                                ?.modeStatus === true
                                ? "Active"
                                : assignedServiceProviderModesData?.[row]
                                      ?.modeStatus === false
                                  ? "Inactive"
                                  : ""
                            }
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={5} md={4} lg={4} />
                  </Row>
                  {assignedServiceProviderData?.serviceProvider
                    ?.serviceTypeId == 4 ? (
                    <>
                      <div className="mp-buttons-container mp-sp-city-selection-header-container">
                        <h4 className="mp-sub-heading-margin">
                          <Checkbox
                            id="mp-checkbox-3"
                            name="mp-service-provider-payment-checkbox"
                            style={{ marginLeft: -13, marginTop: 0 }}
                            disabled={props?.data?.mode == "view" || loading}
                            color={
                              props?.data?.mode == "view"
                                ? "default"
                                : "secondary"
                            }
                            checked={
                              (assignedServiceProviderModesData?.[row]
                                ?.cityMapping?.cityMappingEnabled ?? false)
                                ? true
                                : false
                            }
                            onChange={(eve, proxy) => {
                              // setProviderToCreate({
                              //   ...providerToCreate,
                              //   gymInfo: {
                              //     ...providerToCreate.gymInfo,
                              //     cityMapping: {
                              //       ...providerToCreate?.gymInfo?.cityMapping,
                              //       cityMappingEnabled: eve.target.checked,
                              //     },
                              //   },
                              // });
                              updateAssignedServiceProviderModesDataField(
                                row.toString(),
                                "cityMapping",
                                {
                                  ...(assignedServiceProviderModesData?.[row]
                                    ?.cityMapping ?? {}),
                                  cityMappingEnabled: eve.target.checked,
                                },
                              );
                            }}
                          />
                          {`Enable City selection`}
                        </h4>
                        <h4
                          ref={enablePricePerCityTextRef}
                          className="mp-sub-heading-margin"
                        >
                          <Checkbox
                            id="mp-checkbox-3"
                            name="mp-service-provider-payment-checkbox"
                            style={{ marginLeft: -13, marginTop: 0 }}
                            disabled={props?.data?.mode == "view" || loading}
                            color={
                              props?.data?.mode == "view"
                                ? "default"
                                : "secondary"
                            }
                            checked={
                              (assignedServiceProviderModesData?.[row]
                                ?.cityMapping?.customisedPriceEnabled ?? false)
                                ? true
                                : false
                            }
                            onChange={(eve, proxy) => {
                              // setProviderToCreate({
                              //   ...providerToCreate,
                              //   gymInfo: {
                              //     ...providerToCreate.gymInfo,
                              //     cityMapping: {
                              //       ...providerToCreate?.gymInfo?.cityMapping,
                              //       cityMappingEnabled: eve.target.checked,
                              //     },
                              //   },
                              // });
                              updateAssignedServiceProviderModesDataField(
                                row.toString(),
                                "cityMapping",
                                {
                                  ...(assignedServiceProviderModesData?.[row]
                                    ?.cityMapping ?? {}),
                                  customisedPriceEnabled: eve.target.checked,
                                },
                              );
                            }}
                          />
                          {`Price as per City`}
                        </h4>

                        {/* showing save this SP button if initially the city selection was disabled and now we enabled it. */}
                        {Boolean(
                          ((initialCityMapping?.[row]?.cityMappingEnabled ??
                            false) !=
                            (assignedServiceProviderModesData?.[row]
                              ?.cityMapping?.cityMappingEnabled ?? false) ||
                            (initialCityMapping?.[row]
                              ?.customisedPriceEnabled ?? false) !=
                              (assignedServiceProviderModesData?.[row]
                                ?.cityMapping?.customisedPriceEnabled ??
                                false)) &&
                          props?.data?.mode == "update",
                        ) && (
                          <Button
                            raised
                            disabled={loading}
                            className={
                              loading
                                ? "mp-button-save-disabled"
                                : "mp-button-save-enabled"
                            }
                            onClick={() => {
                              if (
                                Boolean(
                                  (initialCityMapping?.[row]
                                    ?.cityMappingEnabled ?? false) !=
                                    (assignedServiceProviderModesData?.[row]
                                      ?.cityMapping?.cityMappingEnabled ??
                                      false) ||
                                  (initialCityMapping?.[row]
                                    ?.customisedPriceEnabled ?? false) !=
                                    (assignedServiceProviderModesData?.[row]
                                      ?.cityMapping?.customisedPriceEnabled ??
                                      false),
                                )
                              ) {
                                setShowPropagationDialog("cityCheckboxes");
                              } else {
                                assignServiceProvider(
                                  prepareBodyForAssignServiceProvider(),
                                  undefined,
                                  false,
                                  !(
                                    initialCityMapping?.[row]
                                      ?.customisedPriceEnabled ?? false
                                  ) &&
                                    (assignedServiceProviderModesData?.[row]
                                      ?.cityMapping?.customisedPriceEnabled ??
                                      false) == true,
                                );
                              }
                            }}
                          >
                            {props?.data?.mode == 1 ? "Save" : "Update"}
                          </Button>
                        )}
                        {Boolean(
                          !(
                            assignedServiceProviderModesData?.[row]?.cityMapping
                              ?.customisedPriceEnabled ?? false
                          ) ||
                          !(
                            initialCityMapping?.[row]?.customisedPriceEnabled ??
                            false
                          ) ||
                          (initialCityMapping?.[row]?.cityMappingEnabled ??
                            false) !=
                            (assignedServiceProviderModesData?.[row]
                              ?.cityMapping?.cityMappingEnabled ?? false),
                        ) ? (
                          <></>
                        ) : Boolean(cityMappingOperationSelected === 2) ? (
                          <div className="mp-buttons-right-alignment">
                            <Button
                              raised
                              disabled={loading}
                              className={
                                loading
                                  ? "mp-button-save-disabled"
                                  : "mp-button-save-enabled"
                              }
                              onClick={() => {
                                if (cityMappingOperationSelected === 2) {
                                  if (checkIfThereIsAnythingToUpdate()) {
                                    setShowPropagationDialog("cityEntities");
                                  } else {
                                    EventService.emit("showError", {
                                      message: `Nothing to update. Please update at least 1 record.`,
                                    });
                                  }
                                }
                              }}
                            >
                              {"Save"}
                            </Button>

                            <Button
                              raised
                              disabled={loading}
                              className="mp-button-cancel"
                              onClick={() => {
                                handleUpdateMode(originalMode);
                                setCityMappingOperationSelected(null);
                                resetAddOrUpdateCities();
                              }}
                            >
                              {"Cancel"}
                            </Button>
                          </div>
                        ) : (
                          <div className="mp-buttons-right-alignment">
                            {Boolean(
                              (cityMappings?.cityEntities ?? [])?.length > 0 &&
                              props?.data?.mode != "view",
                            ) && (
                              <Button
                                raised
                                disabled={
                                  loading || props?.data?.mode == "view"
                                }
                                className={
                                  loading
                                    ? "mp-button-save-disabled"
                                    : "mp-button-save-enabled"
                                }
                                onClick={() => {
                                  handleUpdateMode("view");
                                  setCityMappingOperationSelected(2);
                                }}
                              >
                                {"Update cities"}
                              </Button>
                            )}
                          </div>
                        )}
                      </div>

                      {Boolean(props?.data?.mode != "assign") && (
                        <>
                          <CityTableAssignSP
                            tableData={returnTableDataWithEditsApplied(
                              cityMappings ?? {},
                              tableDataEditAudits ?? {},
                            )}
                            cityMappingFilters={cityMappingFilters}
                            cityMappings={cityMappings}
                            handleUpdateTableData={handleUpdateTableCityEntity}
                            // handleUpdateNewTableData={
                            //   handleUpdateNewTableCityEntity
                            // }
                            // cityMappingOperationSelected={
                            //   cityMappingOperationSelected
                            // }//
                            assignedServiceProviderData={
                              assignedServiceProviderData
                            }
                            assignedServiceProviderCurrModeData={
                              assignedServiceProviderModesData?.[row]
                            }
                            fetchCityMappings={fetchCityMappings}
                            // serviceProviderId={props?.data?.serviceProviderId}
                            mode={
                              cityMappingOperationSelected === 2
                                ? "update"
                                : "view"
                            }
                            cityMappingOperationSelected={
                              cityMappingOperationSelected
                            }
                            loading={loading}
                          />
                        </>
                      )}

                      <div style={{ height: "48px" }}></div>

                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div className="mp-field-container">
                            <div className="mp-label-2">{`City instruction`}</div>
                            <div
                              style={{
                                borderBottom: "2px solid #E4E4E4",
                                marginTop: "10px",
                              }}
                            >
                              <Editor
                                // toolbarClassName={showToolbar ? null : "toolBar-hidden"}
                                // toolbarClassName={showToolbar ? null : " toolBar-hidden-pn"}

                                readOnly={
                                  props?.data?.mode == "view" ||
                                  cityMappingOperationSelected === 2
                                }
                                editorState={editorStateCityInstruction}
                                wrapperClassName=""
                                editorClassName=""
                                // hashtag={{
                                //   separator: " ",
                                //   trigger: "#",
                                // }}
                                onEditorStateChange={(editorState) =>
                                  _onEditorStateChangeCityInstruction(
                                    editorState,
                                    row,
                                  )
                                }
                                stripPastedStyles={true}
                                placeholder={
                                  <label>{`Please enter city instruction`}</label>
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div style={{ height: "48px" }}></div>

                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div className="mp-field-container">
                            <div className="mp-label-2">{`Phone number and email id instruction`}</div>
                            <div
                              style={{
                                borderBottom: "2px solid #E4E4E4",
                                marginTop: "10px",
                              }}
                            >
                              <Editor
                                // toolbarClassName={showToolbar ? null : "toolBar-hidden"}
                                // toolbarClassName={showToolbar ? null : " toolBar-hidden-pn"}

                                readOnly={
                                  props?.data?.mode == "view" ||
                                  cityMappingOperationSelected === 2
                                }
                                editorState={
                                  editorStatePhoneNoAndEmailInstruction
                                }
                                wrapperClassName=""
                                editorClassName=""
                                // hashtag={{
                                //   separator: " ",
                                //   trigger: "#",
                                // }}
                                onEditorStateChange={(editorState) =>
                                  _onEditorStateChangePhoneNoAndEmailInstruction(
                                    editorState,
                                    row,
                                  )
                                }
                                stripPastedStyles={true}
                                placeholder={
                                  <label>{`Please enter phone number and email id instruction`}</label>
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col xs={12} sm={5} md={4} lg={4}>
                          <div className="mp-field-container">
                            <div className="mp-label">
                              {`Duration (mins)`}
                              <label className="mp-label-red"> *</label>
                            </div>
                            <div>
                              <TextField
                                id="slotDurationInMinutes"
                                name="slotDurationInMinutes"
                                type="number"
                                placeholder="Type here"
                                disabled={props?.data?.mode == "view"}
                                onChange={(e) =>
                                  updateCalendarAvailabilityConfig(
                                    stringToInt(e),
                                    "slotDurationInMinutes",
                                    row.toString(),
                                  )
                                }
                                value={
                                  assignedServiceProviderModesData?.[row]
                                    ?.availability?.config
                                    ?.slotDurationInMinutes
                                }
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={5} md={4} lg={4}>
                          <div className="mp-field-container">
                            <div className="mp-label">
                              {`Booking per slot`}
                              <label className="mp-label-red"> *</label>
                            </div>
                            <div>
                              <TextField
                                id="bookingPerSlot"
                                name="bookingPerSlot"
                                type="number"
                                placeholder="Type here"
                                disabled={props?.data?.mode == "view"}
                                onChange={(e) =>
                                  updateCalendarAvailabilityConfig(
                                    stringToInt(e),
                                    "bookingPerSlot",
                                    row.toString(),
                                  )
                                }
                                value={
                                  assignedServiceProviderModesData?.[row]
                                    ?.availability?.config?.bookingPerSlot
                                }
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={5} md={4} lg={4} />
                      </Row>
                      <Row>
                        <Col xs={12} sm={5} md={4} lg={4}>
                          <div className="mp-field-container">
                            <div className="mp-label">
                              {`Min booking notice (days)`}
                              <label className="mp-label-red"> *</label>
                            </div>
                            <div>
                              <TextField
                                id="minBookingDays"
                                name="minBookingDays"
                                type="number"
                                placeholder="Type here"
                                disabled={props?.data?.mode == "view"}
                                onChange={(e) =>
                                  updateCalendarAvailabilityConfig(
                                    stringToInt(e),
                                    "minBookingDays",
                                    row.toString(),
                                  )
                                }
                                value={
                                  assignedServiceProviderModesData?.[row]
                                    ?.availability?.config?.minBookingDays
                                }
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={5} md={4} lg={4}>
                          <div className="mp-field-container">
                            <div className="mp-label">
                              {`Max advance booking (days)`}
                              <label className="mp-label-red"> *</label>
                            </div>
                            <div>
                              <TextField
                                id="maxAdvBookingDays"
                                name="maxAdvBookingDays"
                                type="number"
                                placeholder="Type here"
                                disabled={props?.data?.mode == "view"}
                                onChange={(e) =>
                                  updateCalendarAvailabilityConfig(
                                    stringToInt(e),
                                    "maxAdvBookingDays",
                                    row.toString(),
                                  )
                                }
                                value={
                                  assignedServiceProviderModesData?.[row]
                                    ?.availability?.config?.maxAdvBookingDays
                                }
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={5} md={4} lg={4} />
                      </Row>
                      <div style={{ height: "25px" }}></div>
                      <AvailabilityCalendar
                        availability={
                          assignedServiceProviderModesData?.[row]
                            ?.availability ?? {
                            config: {},
                            schedule: {
                              sunday: [],
                              monday: [],
                              tuesday: [],
                              wednesday: [],
                              thursday: [],
                              friday: [],
                              saturday: [],
                            },
                            unavailableTime: [],
                            availableTime: [],
                          }
                        }
                        setAvailability={(newAvailability) =>
                          setAvailability(newAvailability, row?.toString())
                        }
                        mode={props?.data?.mode == "view" ? 2 : 1} // if 2 -> view mode , else , edit/create
                        headings={calendarHeadings}
                        slotsValidationSchedule={
                          assignedServiceProviderData?.masterAvailability
                            ?.schedule ?? {
                            sunday: [],
                            monday: [],
                            tuesday: [],
                            wednesday: [],
                            thursday: [],
                            friday: [],
                            saturday: [],
                          }
                        }
                        showAvailabilityUnavailabilityInViewOnly={true}
                      />
                    </>
                  )}
                </div>
              )
            }
          />
        ))}
      </ExpansionList>
    );
  };

  let calendarHeadings = [
    "Default weekly schedule of the provider",
    "Service provider unavailability beyond default weekly schedule",
    "Service provider availability beyond default weekly schedule",
    "availability beyond default weekly schedule",
  ];

  return (
    <div className="outermost-div">
      <div className="heading-outer-container">
        <div className="heading-inner-container">
          <div
            className="heading-back-arrow"
            onClick={() => {
              exitPage();
            }}
          >
            <FontIcon style={{ fontSize: "36px", marginTop: "-7px" }}>
              arrow_back
            </FontIcon>
          </div>
          <div className="heading-inner-container-text-and-btns">
            <h1 className="heading-text">
              {props?.data?.mode == "assign"
                ? `Assign new service provider`
                : props?.data?.mode == "update"
                  ? `Edit Assigned service provider`
                  : `Assigned service provider`}
            </h1>
            {props?.data?.mode != "view" && (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Button
                  raised
                  secondary
                  style={{
                    textTransform: "none",
                  }}
                  onClick={() => {
                    if (
                      (serviceTypeData?.modes ?? [])?.some((row) =>
                        Boolean(
                          (initialCityMapping?.[row]?.cityMappingEnabled ??
                            false) !=
                            (assignedServiceProviderModesData?.[row]
                              ?.cityMapping?.cityMappingEnabled ?? false) ||
                          (initialCityMapping?.[row]?.customisedPriceEnabled ??
                            false) !=
                            (assignedServiceProviderModesData?.[row]
                              ?.cityMapping?.customisedPriceEnabled ?? false),
                        ),
                      ) &&
                      props?.data?.mode == "update"
                    ) {
                      setShowPropagationDialog("cityCheckboxes");
                    } else {
                      assignServiceProvider(
                        prepareBodyForAssignServiceProvider(),
                        undefined,
                        false,
                        (serviceTypeData?.modes ?? [])?.some(
                          (row) =>
                            !(
                              initialCityMapping?.[row]
                                ?.customisedPriceEnabled ?? false
                            ) &&
                            (assignedServiceProviderModesData?.[row]
                              ?.cityMapping?.customisedPriceEnabled ?? false) ==
                              true,
                        ),
                      );
                    }
                  }}
                  disabled={!assignedServiceProviderData?.isContinueClicked}
                >
                  Save
                </Button>
                <div style={{ width: "15px" }}></div>
                <Button
                  raised
                  style={{
                    color: "#333333",
                    backgroundColor: "#EBEBEB",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    exitPage();
                  }}
                >
                  Cancel
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div style={{ height: "40px" }}></div>
      {getServiceDetailsSection()}
      <div style={{ height: "60px" }}></div>
      <h3 className="heading-h3">Service provider details</h3>
      <div style={{ height: "16px" }}></div>
      {getServiceProviderDetailsSection()}
      <div style={{ height: "60px" }}></div>
      {(assignedServiceProviderData?.isContinueClicked ?? false) && (
        <>
          <h3 className="heading-h3">Service mode details</h3>
          <div style={{ height: "16px" }}></div>
          {getServiceModesSection()}
        </>
      )}
      {openPropCalendarChangesDialog && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog-2"
          visible={openPropCalendarChangesDialog}
          focusOnMount={false}
          onHide={() => {
            setOpenPropCalendarChangesDialog(false);
            setSPbodyToUpdate(null);
          }}
          width="500px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-2">
            <div>{`Do you want the changes in the calendar to be reflected`}</div>
            <div>{`in the customised calendar?`}</div>
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    if (SPbodyToUpdate != null) {
                      assignServiceProvider(SPbodyToUpdate, 1);
                    }
                  }}
                >
                  {"Yes"}
                </Button>

                <Button
                  raised
                  className="mp-button-cancel"
                  onClick={() => {
                    if (SPbodyToUpdate != null) {
                      assignServiceProvider(SPbodyToUpdate, 2);
                    }
                  }}
                >
                  {"No"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}

      {/* Error Dialog */}
      {Boolean(
        Boolean(errorObject) &&
        Boolean(errorObject?.operation === 1 || errorObject?.operation === 2),
      ) && (
        <div className="modal-overlay">
          <div className="modal error-modal">
            <h3>
              Error{" "}
              {errorObject?.operation === 1
                ? "Adding"
                : errorObject?.operation === 2
                  ? "Updating"
                  : ""}{" "}
              City/Cities
            </h3>
            <div className="error-modal-content" style={{ textAlign: "left" }}>
              <p>
                {(errorObject?.totalRequested ?? 0) -
                  (errorObject?.totalErrors ?? 0)}{" "}
                out of {errorObject?.totalRequested ?? 0} city/cities have been{" "}
                {errorObject?.operation === 1
                  ? "added"
                  : errorObject?.operation === 2
                    ? "updated"
                    : ""}{" "}
                successfully but there are some errors in{" "}
                {errorObject?.totalErrors ?? 0} city/cities, please rectify and
                try again
              </p>

              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  textAlign: "left",
                  paddingRight: "10px",
                }}
              >
                {errorObject?.operation === 1
                  ? Object.entries(errorObject?.errorResponse ?? {}).map(
                      ([city, errMsg], index) => (
                        <div key={index} style={{ marginBottom: "10px" }}>
                          <strong>City:</strong> {city} <br />
                          <strong>Error:</strong> {errMsg}
                        </div>
                      ),
                    )
                  : errorObject?.operation === 2
                    ? Object.entries(errorObject?.errorResponse ?? {}).map(
                        ([key, value], index) => (
                          <div key={index} style={{ marginBottom: "10px" }}>
                            <strong>City:</strong> {value?.city} <br />
                            <strong>Error:</strong> {value?.errorMessage}
                          </div>
                        ),
                      )
                    : ""}
              </div>
            </div>

            <div style={{ height: "32px" }}></div>
            <Button
              raised
              className={"mp-button-save-enabled"}
              onClick={() => setErrorObject(null)}
            >
              {"Okay"}
            </Button>
            <div style={{ height: "32px" }}></div>
          </div>
        </div>
      )}

      {(showPropagationDialog == "cityCheckboxes" ||
        showPropagationDialog == "cityEntities") && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog"
          visible={showPropagationDialog}
          focusOnMount={false}
          onHide={() => {
            // setOpenPropCalendarChangesDialog(false);
            // setSPbodyToUpdate(null);
            // setLoading(false);
          }}
          width="500px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left", zIndex: 200 }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-1">
            <h3>
              <br />
            </h3>
            <br />
            <div>{`Do you want to propagate the changes on subsequent levels?`}</div>
            <br />
            {/* <div>{`in the default calendar and customised calendar?`}</div> */}
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    if (showPropagationDialog == "cityCheckboxes") {
                      assignServiceProvider(
                        prepareBodyForAssignServiceProvider(),
                        undefined,
                        true,
                        (serviceTypeData?.modes ?? [])?.some(
                          (row) =>
                            !(
                              initialCityMapping?.[row]
                                ?.customisedPriceEnabled ?? false
                            ) &&
                            (assignedServiceProviderModesData?.[row]
                              ?.cityMapping?.customisedPriceEnabled ?? false) ==
                              true,
                        ),
                      );
                    } else if (showPropagationDialog == "cityEntities") {
                      updateSPCityToPriceMapping(true);
                      // just adding updating assignServiceProvider update call for covering corner case..
                      assignServiceProvider(
                        prepareBodyForAssignServiceProvider(),
                        undefined,
                        true,
                        false,
                      );
                    }

                    setShowPropagationDialog(null);
                  }}
                >
                  {"Yes"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    if (showPropagationDialog == "cityCheckboxes") {
                      assignServiceProvider(
                        prepareBodyForAssignServiceProvider(),
                        undefined,
                        false,
                        (serviceTypeData?.modes ?? [])?.some(
                          (row) =>
                            !(
                              initialCityMapping?.[row]
                                ?.customisedPriceEnabled ?? false
                            ) &&
                            (assignedServiceProviderModesData?.[row]
                              ?.cityMapping?.customisedPriceEnabled ?? false) ==
                              true,
                        ),
                      );
                    } else if (showPropagationDialog == "cityEntities") {
                      updateSPCityToPriceMapping(false);
                    }
                    setShowPropagationDialog(null);
                  }}
                >
                  {"No"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}

      {showUpdateCityMappingNowDialog && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog"
          visible={showUpdateCityMappingNowDialog}
          focusOnMount={false}
          onHide={() => {
            // setOpenPropCalendarChangesDialog(false);
            // setSPbodyToUpdate(null);
            // setLoading(false);
          }}
          width="650px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left", zIndex: 200 }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-1">
            <h3>{`Service provider assignment ${
              mode == "assign" ? `created` : mode == "update" ? `updated` : ``
            } successfully!`}</h3>
            <br />
            <div>{`Do you want to add/update cities now or later?`}</div>
            <br />
            {/* <div>{`in the default calendar and customised calendar?`}</div> */}
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    setLoading(false);
                    setShowUpdateCityMappingNowDialog(false);

                    getAssignedServiceProvidersDataByFilter({
                      pageNum: 1,
                      pageSize: 1,
                      serviceIds: [assignedServiceProviderData?.service?.id],
                      serviceProviderIds: [
                        assignedServiceProviderData?.serviceProvider?.id,
                      ],
                    });

                    handleUpdateMode("update");
                    scrollToPricePerCityHeading();
                  }}
                >
                  {"Now"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    setLoading(false);
                    setShowUpdateCityMappingNowDialog(false);
                    exitPage();
                  }}
                >
                  {"Later"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}
      {getAllAgreementsModal()}
      {showAddAgreementDialog && getAddAgreementDialog()}
      {showEditAgreementDialog && getEditAgreementDialog()}
      {getViewAuditModal()}
      {agreementMenuIndex != null &&
        agreementMenuAnchor &&
        (() => {
          const item = agreementMenuItem;
          if (!item) return null;
          const isModal =
            typeof agreementMenuIndex === "string" &&
            agreementMenuIndex.startsWith("modal-");
          const actualIndex = isModal
            ? parseInt(agreementMenuIndex.replace("modal-", ""), 10)
            : agreementMenuIndex;
          return (
            <>
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 999,
                }}
                onClick={() => {
                  setAgreementMenuAnchor(null);
                  setAgreementMenuIndex(null);
                  setAgreementMenuItem(null);
                }}
              />
              <div
                className="agreement-menu-dropdown"
                style={{
                  position: "fixed",
                  top: agreementMenuPosition.top,
                  left: agreementMenuPosition.left,
                  zIndex: 1000,
                }}
              >
                {props?.data?.mode !== "view" && (
                  <div
                    className="agreement-menu-item"
                    onClick={() => {
                      setAgreementMenuAnchor(null);
                      setAgreementMenuIndex(null);
                      setAgreementMenuItem(null);
                      handleOpenEditAgreementDialog(item, actualIndex);
                    }}
                  >
                    <FontIcon style={{ fontSize: "16px", marginRight: "8px" }}>
                      edit
                    </FontIcon>
                    Edit
                  </div>
                )}
                <div
                  className="agreement-menu-item"
                  onClick={() => {
                    setAgreementMenuAnchor(null);
                    setAgreementMenuIndex(null);
                    setAgreementMenuItem(null);
                    handleViewAudit(item);
                  }}
                >
                  <FontIcon style={{ fontSize: "16px", marginRight: "8px" }}>
                    visibility
                  </FontIcon>
                  View audits
                </div>
              </div>
            </>
          );
        })()}
    </div>
  );
}

export default ServiceProviderActionScreen;
